import React, { useState, useEffect, useCallback } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Badge } from "../components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { 
  Receipt, Upload, Loader2, Plus, Trash2, Euro, TrendingUp, TrendingDown,
  FileText, Calendar, Building2, BarChart3, Percent, CreditCard, CheckCircle,
  Clock, AlertCircle, Eye, Edit, Save, X, Calculator, PiggyBank, Banknote,
  Download, FileSpreadsheet, Ticket, Cross, Coffee, UtensilsCrossed, Cake, AlertTriangle,
  Users, Briefcase, Wallet, Package, Car, Megaphone, Shield, Sparkles, CircleHelp, CheckSquare, ArrowRightLeft, Gift, RefreshCw
} from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CATEGORIES = ["Bière", "Cidre", "Soft", "Cocktail", "Divers", "Emballage"];

const CATEGORY_COLORS = {
  "Bière": "bg-amber-100 text-amber-800 border-amber-300",
  "Cidre": "bg-orange-100 text-orange-800 border-orange-300",
  "Soft": "bg-blue-100 text-blue-800 border-blue-300",
  "Cocktail": "bg-purple-100 text-purple-800 border-purple-300",
  "Divers": "bg-gray-100 text-gray-800 border-gray-300",
  "Emballage": "bg-green-100 text-green-800 border-green-300"
};

const CoutReelHECPage = () => {
  const { user } = useAuth();
  
  // Check if user is the super admin (only they can reclassify)
  const isSuperAdmin = user?.email === "admin@foodtruckunited.fr";
  
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState("synthese");
  
  // Reclassement montants personnalisés (admin only)
  const [showReclassementDialog, setShowReclassementDialog] = useState(false);
  const [reclassementItem, setReclassementItem] = useState(null);
  const [reclassementTarget, setReclassementTarget] = useState({ food_truck: "", article: "" });
  const [savingReclassement, setSavingReclassement] = useState(false);
  
  // Invoice dialog
  const [showInvoiceDialog, setShowInvoiceDialog] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [savingInvoice, setSavingInvoice] = useState(false);
  
  // OCR
  const [uploading, setUploading] = useState(false);
  const [ocrResult, setOcrResult] = useState(null);
  
  // Acompte dialog
  const [showAcompteDialog, setShowAcompteDialog] = useState(false);
  const [newAcompte, setNewAcompte] = useState({ montant: "", date_paiement: "", notes: "" });
  const [savingAcompte, setSavingAcompte] = useState(false);
  
  // Ventes
  const [ventes, setVentes] = useState({ biere: 0, cidre: 0, soft: 0, cocktail: 0, vin_blanc: 0, vin_rouge: 0, vin_rose: 0 });
  const [savingVentes, setSavingVentes] = useState(false);
  
  // MBAT
  const [mbatData, setMbatData] = useState(null);
  const [uploadingMbat, setUploadingMbat] = useState(false);
  const [mbatSelectedFoodTruck, setMbatSelectedFoodTruck] = useState(null);
  const [mbatViewMode, setMbatViewMode] = useState("foodtrucks"); // "foodtrucks", "articles", "jetons", "croixblanche", "unassigned"
  
  // Renommer Food Truck MBAT
  const [showRenameDialog, setShowRenameDialog] = useState(false);
  const [renameData, setRenameData] = useState({ old_name: "", new_name: "" });
  const [savingRename, setSavingRename] = useState(false);
  
  // Jetons
  const [jetonsData, setJetonsData] = useState(null);
  const [showJetonDialog, setShowJetonDialog] = useState(false);
  const [showRenameJetonDialog, setShowRenameJetonDialog] = useState(false);
  const [renameJetonData, setRenameJetonData] = useState({ old_name: "", new_name: "" });
  const [savingJetonRename, setSavingJetonRename] = useState(false);
  const [showDeleteJetonFTDialog, setShowDeleteJetonFTDialog] = useState(false);
  const [deleteJetonFT, setDeleteJetonFT] = useState("");
  const [deletingJetonFT, setDeletingJetonFT] = useState(false);
  const [newJeton, setNewJeton] = useState({ food_truck: "", date: "", service: "midi", quantite: 1, notes: "" });
  const [savingJeton, setSavingJeton] = useState(false);
  
  // Croix Blanche
  const [croixBlancheData, setCroixBlancheData] = useState(null);
  const [showCroixBlancheDialog, setShowCroixBlancheDialog] = useState(false);
  const [newCroixBlanche, setNewCroixBlanche] = useState({ 
    food_truck: "", date: "", type: "plat", description: "", quantite: 1, prix_unitaire: 0, notes: "" 
  });
  const [savingCroixBlanche, setSavingCroixBlanche] = useState(false);
  
  // Staff Réel
  const [staffData, setStaffData] = useState(null);
  const [showStaffDialog, setShowStaffDialog] = useState(false);
  const [newStaff, setNewStaff] = useState({ 
    nom: "", role: "barman", date: "", heures_prevues: 0, heures_reelles: 0, taux_horaire: 12.50, notes: "" 
  });
  const [savingStaff, setSavingStaff] = useState(false);
  
  // Staff from Planning HEC
  const [staffFromPlanning, setStaffFromPlanning] = useState(null);
  const [loadingPlanningStaff, setLoadingPlanningStaff] = useState(false);
  const [showImportStaffDialog, setShowImportStaffDialog] = useState(false);
  const [staffImportData, setStaffImportData] = useState([]);
  const [importingStaff, setImportingStaff] = useState(false);
  
  // Dépenses Manuelles
  const [depensesData, setDepensesData] = useState(null);
  const [showDepenseDialog, setShowDepenseDialog] = useState(false);
  const [newDepense, setNewDepense] = useState({
    description: "", categorie: "materiel", date: "", montant: 0, fournisseur: "", notes: ""
  });
  const [savingDepense, setSavingDepense] = useState(false);
  
  // Synthèse Globale
  const [syntheseData, setSyntheseData] = useState(null);
  
  // Synthèse par Food Truck
  const [syntheseFTData, setSyntheseFTData] = useState(null);
  
  // Transactions sans catégorie
  const [unassignedData, setUnassignedData] = useState(null);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [assigningTo, setAssigningTo] = useState("");
  const [isAssigning, setIsAssigning] = useState(false);

  const token = localStorage.getItem("token");

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/data`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setData(response.data);
      setVentes(response.data.ventes || { biere: 0, cidre: 0, soft: 0, cocktail: 0, vin_blanc: 0, vin_rouge: 0, vin_rose: 0 });
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Erreur lors du chargement des données");
    } finally {
      setLoading(false);
    }
  }, [token]);

  // Fetch latest MBAT data
  const fetchMbatData = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/mbat/latest`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        setMbatData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching MBAT data:", error);
    }
  }, [token]);

  // Fetch Jetons data
  const fetchJetonsData = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/jetons`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        setJetonsData(response.data);
      }
    } catch (error) {
      console.error("Error fetching Jetons data:", error);
    }
  }, [token]);

  // Fetch Croix Blanche data
  const fetchCroixBlancheData = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/croix-blanche`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        setCroixBlancheData(response.data);
      }
    } catch (error) {
      console.error("Error fetching Croix Blanche data:", error);
    }
  }, [token]);

  // Fetch Staff data
  const fetchStaffData = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/staff`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        setStaffData(response.data);
      }
    } catch (error) {
      console.error("Error fetching Staff data:", error);
    }
  }, [token]);

  // Fetch Staff from HEC Planning
  const fetchStaffFromPlanning = useCallback(async () => {
    setLoadingPlanningStaff(true);
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/staff/from-planning`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        setStaffFromPlanning(response.data);
        // Initialize import data with planning hours
        const importData = response.data.staff.map(s => ({
          staff_id: s.id,
          nom: s.nom,
          fonction: s.fonction,
          taux_horaire: s.taux_horaire,
          benevole: s.benevole,
          heures_prevues_jeudi: s.heures_prevues?.jeudi || 0,
          heures_prevues_vendredi: s.heures_prevues?.vendredi || 0,
          heures_prevues_samedi: s.heures_prevues?.samedi || 0,
          heures_reelles_jeudi: s.heures_prevues?.jeudi || 0,  // Default to planned
          heures_reelles_vendredi: s.heures_prevues?.vendredi || 0,
          heures_reelles_samedi: s.heures_prevues?.samedi || 0,
        }));
        setStaffImportData(importData);
      }
    } catch (error) {
      console.error("Error fetching staff from planning:", error);
      toast.error("Erreur lors du chargement du planning staff");
    }
    setLoadingPlanningStaff(false);
  }, [token]);

  // Import staff from planning
  const handleImportStaffFromPlanning = async () => {
    setImportingStaff(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/cout-reel-hec/staff/import-from-planning`,
        staffImportData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.status === "success") {
        toast.success(`${response.data.imported_count} entrées importées`);
        setShowImportStaffDialog(false);
        fetchStaffData();
      }
    } catch (error) {
      console.error("Error importing staff:", error);
      toast.error("Erreur lors de l'import");
    }
    setImportingStaff(false);
  };

  // Clear all staff entries
  const handleClearAllStaff = async () => {
    if (!window.confirm("Supprimer toutes les entrées staff ? Cette action est irréversible.")) return;
    try {
      const response = await axios.delete(`${API_URL}/api/cout-reel-hec/staff/clear-all`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        toast.success(`${response.data.deleted_count} entrées supprimées`);
        fetchStaffData();
      }
    } catch (error) {
      console.error("Error clearing staff:", error);
      toast.error("Erreur lors de la suppression");
    }
  };

  // Update import data for a staff member
  const updateStaffImportData = (staffId, field, value) => {
    setStaffImportData(prev => prev.map(s => 
      s.staff_id === staffId ? { ...s, [field]: parseFloat(value) || 0 } : s
    ));
  };

  // Fetch Dépenses data
  const fetchDepensesData = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/depenses`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        setDepensesData(response.data);
      }
    } catch (error) {
      console.error("Error fetching Depenses data:", error);
    }
  }, [token]);

  // Fetch Synthèse Globale
  const fetchSyntheseData = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/synthese-globale`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        setSyntheseData(response.data);
      }
    } catch (error) {
      console.error("Error fetching Synthese data:", error);
    }
  }, [token]);

  // Fetch Synthèse par Food Truck
  const fetchSyntheseFT = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/synthese-food-trucks`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        setSyntheseFTData(response.data);
      }
    } catch (error) {
      console.error("Error fetching Synthese FT data:", error);
    }
  }, [token]);

  // Fetch Unassigned Transactions
  const fetchUnassignedData = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/mbat/unassigned`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status === "success") {
        setUnassignedData(response.data);
      }
    } catch (error) {
      console.error("Error fetching Unassigned data:", error);
    }
  }, [token]);

  useEffect(() => {
    fetchData();
    fetchMbatData();
    fetchJetonsData();
    fetchCroixBlancheData();
    fetchStaffData();
    fetchDepensesData();
    fetchSyntheseData();
    fetchSyntheseFT();
    fetchUnassignedData();
  }, [fetchData, fetchMbatData, fetchJetonsData, fetchCroixBlancheData, fetchStaffData, fetchDepensesData, fetchSyntheseData, fetchSyntheseFT, fetchUnassignedData]);

  // MBAT Upload
  const handleMbatUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploadingMbat(true);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `${API_URL}/api/cout-reel-hec/mbat/import`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      if (response.data.status === "success") {
        toast.success(`${response.data.total_transactions} transactions importées`);
        setMbatData({
          ...response.data,
          uploaded_at: new Date().toISOString()
        });
        setMbatSelectedFoodTruck(null);
      }
    } catch (error) {
      console.error("MBAT upload error:", error);
      toast.error(error.response?.data?.detail || "Erreur lors de l'import");
    } finally {
      setUploadingMbat(false);
    }
  };

  // Export MBAT
  const handleExportMbat = async (format) => {
    try {
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/mbat/export/${format}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `mbat_export.${format}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success(`Export ${format.toUpperCase()} téléchargé`);
    } catch (error) {
      toast.error("Erreur lors de l'export");
    }
  };

  // Delete all MBAT data
  const [showDeleteMbatDialog, setShowDeleteMbatDialog] = useState(false);
  const [deletingMbat, setDeletingMbat] = useState(false);
  
  const handleDeleteAllMbat = async () => {
    try {
      setDeletingMbat(true);
      const response = await axios.delete(`${API_URL}/api/cout-reel-hec/mbat-all`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      toast.success(response.data.message || "Données MBAT supprimées");
      setMbatData(null);
      setShowDeleteMbatDialog(false);
      fetchData(); // Refresh all data
    } catch (error) {
      console.error("Delete MBAT error:", error);
      toast.error(error.response?.data?.detail || "Erreur lors de la suppression");
    } finally {
      setDeletingMbat(false);
    }
  };

  // Rename Food Truck in MBAT
  const handleRenameFoodTruck = async () => {
    if (!renameData.old_name || !renameData.new_name) {
      toast.error("Veuillez remplir les deux champs");
      return;
    }
    
    try {
      setSavingRename(true);
      const response = await axios.post(
        `${API_URL}/api/cout-reel-hec/mbat/rename-foodtruck`,
        renameData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success(response.data.message || "Food truck renommé");
      setShowRenameDialog(false);
      setRenameData({ old_name: "", new_name: "" });
      fetchMbatData(); // Refresh MBAT data
    } catch (error) {
      console.error("Rename error:", error);
      toast.error(error.response?.data?.detail || "Erreur lors du renommage");
    } finally {
      setSavingRename(false);
    }
  };

  // Export Complet HEC (Excel multi-feuilles)
  const handleExportComplet = async () => {
    try {
      toast.info("Génération de l'export en cours...");
      const response = await axios.get(`${API_URL}/api/cout-reel-hec/export-complet`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = `cout_reel_hec_export_${new Date().toISOString().slice(0, 10)}.xlsx`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Export complet téléchargé");
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Erreur lors de l'export complet");
    }
  };

  // Reclasser Montant Personnalisé (Admin only)
  const handleReclasserMontant = async () => {
    if (!reclassementItem || !reclassementTarget.food_truck || !reclassementTarget.article) {
      toast.error("Veuillez sélectionner un food truck et un article");
      return;
    }
    
    setSavingReclassement(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/cout-reel-hec/mbat/reclasser-montant`,
        {
          montant_id: reclassementItem.id,
          new_food_truck: reclassementTarget.food_truck,
          new_article: reclassementTarget.article
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (response.data.status === "success") {
        toast.success(response.data.message);
        setShowReclassementDialog(false);
        setReclassementItem(null);
        setReclassementTarget({ food_truck: "", article: "" });
        fetchMbatData(); // Refresh data
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors du reclassement");
    } finally {
      setSavingReclassement(false);
    }
  };

  // Get articles for a food truck
  const getArticlesForFoodTruck = (ftName) => {
    const ft = mbatData?.food_trucks?.find(f => f.nom === ftName);
    return ft?.articles?.map(a => a.nom) || [];
  };

  // Add Jeton
  const handleAddJeton = async () => {
    if (!newJeton.food_truck || !newJeton.date || newJeton.quantite < 1) {
      toast.error("Veuillez remplir tous les champs obligatoires");
      return;
    }
    
    setSavingJeton(true);
    try {
      await axios.post(`${API_URL}/api/cout-reel-hec/jetons`, newJeton, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Jeton ajouté");
      setShowJetonDialog(false);
      setNewJeton({ food_truck: "", date: "", quantite: 1, notes: "" });
      fetchJetonsData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'ajout");
    } finally {
      setSavingJeton(false);
    }
  };

  // Delete Jeton
  const handleDeleteJeton = async (id) => {
    if (!window.confirm("Supprimer ce jeton ?")) return;
    try {
      await axios.delete(`${API_URL}/api/cout-reel-hec/jetons/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Jeton supprimé");
      fetchJetonsData();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    }
  };

  // Rename Food Truck in Jetons
  const handleRenameJetonFoodTruck = async () => {
    if (!renameJetonData.old_name || !renameJetonData.new_name) {
      toast.error("Veuillez remplir les deux champs");
      return;
    }
    
    try {
      setSavingJetonRename(true);
      const response = await axios.post(
        `${API_URL}/api/cout-reel-hec/jetons/rename-foodtruck`,
        renameJetonData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success(response.data.message || "Food truck renommé dans les Jetons");
      setShowRenameJetonDialog(false);
      setRenameJetonData({ old_name: "", new_name: "" });
      fetchJetonsData(); // Refresh Jetons data
    } catch (error) {
      console.error("Rename jeton error:", error);
      toast.error(error.response?.data?.detail || "Erreur lors du renommage");
    } finally {
      setSavingJetonRename(false);
    }
  };

  // Delete all Jetons for a Food Truck
  const handleDeleteJetonFoodTruck = async () => {
    if (!deleteJetonFT) {
      toast.error("Veuillez sélectionner un food truck");
      return;
    }
    
    try {
      setDeletingJetonFT(true);
      const response = await axios.post(
        `${API_URL}/api/cout-reel-hec/jetons/delete-foodtruck`,
        { food_truck: deleteJetonFT },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success(response.data.message || "Jetons supprimés");
      setShowDeleteJetonFTDialog(false);
      setDeleteJetonFT("");
      fetchJetonsData(); // Refresh Jetons data
    } catch (error) {
      console.error("Delete jeton FT error:", error);
      toast.error(error.response?.data?.detail || "Erreur lors de la suppression");
    } finally {
      setDeletingJetonFT(false);
    }
  };

  // Add Croix Blanche
  const handleAddCroixBlanche = async () => {
    if (!newCroixBlanche.food_truck || !newCroixBlanche.date || !newCroixBlanche.description) {
      toast.error("Veuillez remplir tous les champs obligatoires");
      return;
    }
    
    setSavingCroixBlanche(true);
    try {
      await axios.post(`${API_URL}/api/cout-reel-hec/croix-blanche`, newCroixBlanche, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Entrée Croix Blanche ajoutée");
      setShowCroixBlancheDialog(false);
      setNewCroixBlanche({ food_truck: "", date: "", type: "plat", description: "", quantite: 1, prix_unitaire: 0, notes: "" });
      fetchCroixBlancheData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'ajout");
    } finally {
      setSavingCroixBlanche(false);
    }
  };

  // Delete Croix Blanche
  const handleDeleteCroixBlanche = async (id) => {
    if (!window.confirm("Supprimer cette entrée ?")) return;
    try {
      await axios.delete(`${API_URL}/api/cout-reel-hec/croix-blanche/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Entrée supprimée");
      fetchCroixBlancheData();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    }
  };

  // Add Staff
  const handleAddStaff = async () => {
    if (!newStaff.nom || !newStaff.date) {
      toast.error("Veuillez remplir le nom et la date");
      return;
    }
    
    setSavingStaff(true);
    try {
      await axios.post(`${API_URL}/api/cout-reel-hec/staff`, newStaff, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Staff ajouté");
      setShowStaffDialog(false);
      setNewStaff({ nom: "", role: "barman", date: "", heures_prevues: 0, heures_reelles: 0, taux_horaire: 12.50, notes: "" });
      fetchStaffData();
      fetchSyntheseData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'ajout");
    } finally {
      setSavingStaff(false);
    }
  };

  // Delete Staff
  const handleDeleteStaff = async (id) => {
    if (!window.confirm("Supprimer cette entrée staff ?")) return;
    try {
      await axios.delete(`${API_URL}/api/cout-reel-hec/staff/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Staff supprimé");
      fetchStaffData();
      fetchSyntheseData();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    }
  };

  // Add Dépense
  const handleAddDepense = async () => {
    if (!newDepense.description || !newDepense.date || newDepense.montant <= 0) {
      toast.error("Veuillez remplir tous les champs obligatoires");
      return;
    }
    
    setSavingDepense(true);
    try {
      await axios.post(`${API_URL}/api/cout-reel-hec/depenses`, newDepense, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Dépense ajoutée");
      setShowDepenseDialog(false);
      setNewDepense({ description: "", categorie: "materiel", date: "", montant: 0, fournisseur: "", notes: "" });
      fetchDepensesData();
      fetchSyntheseData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'ajout");
    } finally {
      setSavingDepense(false);
    }
  };

  // Delete Dépense
  const handleDeleteDepense = async (id) => {
    if (!window.confirm("Supprimer cette dépense ?")) return;
    try {
      await axios.delete(`${API_URL}/api/cout-reel-hec/depenses/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Dépense supprimée");
      fetchDepensesData();
      fetchSyntheseData();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    }
  };

  // Get list of food trucks for dropdowns
  const getFoodTrucksList = () => {
    const ftSet = new Set();
    
    // From MBAT data
    if (mbatData?.food_trucks) {
      mbatData.food_trucks.forEach(ft => {
        if (ft.nom) ftSet.add(ft.nom);
      });
    }
    
    // From Jetons data (Planning HEC linked)
    if (jetonsData?.food_truck_results) {
      jetonsData.food_truck_results.forEach(ft => {
        if (ft.food_truck) ftSet.add(ft.food_truck);
      });
    }
    
    // From Croix Blanche data
    if (croixBlancheData?.entries) {
      croixBlancheData.entries.forEach(entry => {
        if (entry.food_truck) ftSet.add(entry.food_truck);
      });
    }
    
    return Array.from(ftSet).sort();
  };

  // Toggle transaction selection
  const toggleTransactionSelection = (id) => {
    setSelectedTransactions(prev => 
      prev.includes(id) ? prev.filter(t => t !== id) : [...prev, id]
    );
  };

  // Select all transactions
  const selectAllTransactions = () => {
    if (unassignedData?.transactions) {
      setSelectedTransactions(unassignedData.transactions.map(t => t.id));
    }
  };

  // Deselect all transactions
  const deselectAllTransactions = () => {
    setSelectedTransactions([]);
  };

  // Assign selected transactions
  const handleAssignTransactions = async () => {
    if (selectedTransactions.length === 0) {
      toast.error("Sélectionnez au moins une transaction");
      return;
    }
    if (!assigningTo) {
      toast.error("Sélectionnez un food truck");
      return;
    }

    setIsAssigning(true);
    try {
      const response = await axios.post(`${API_URL}/api/cout-reel-hec/mbat/assign`, {
        transaction_ids: selectedTransactions,
        food_truck: assigningTo
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success(`${response.data.assigned_count} transaction(s) assignée(s) à ${assigningTo}`);
      setSelectedTransactions([]);
      setAssigningTo("");
      fetchUnassignedData();
      fetchMbatData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'assignation");
    } finally {
      setIsAssigning(false);
    }
  };

  // Assign all transactions from a compte
  const handleAssignByCompte = async (compte, foodTruck) => {
    if (!foodTruck) {
      toast.error("Sélectionnez un food truck");
      return;
    }

    setIsAssigning(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/cout-reel-hec/mbat/assign-by-compte?compte=${encodeURIComponent(compte)}&food_truck=${encodeURIComponent(foodTruck)}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(`${response.data.assigned_count} transaction(s) du compte "${compte}" assignée(s) à ${foodTruck}`);
      fetchUnassignedData();
      fetchMbatData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'assignation");
    } finally {
      setIsAssigning(false);
    }
  };

  // OCR Upload
  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    setOcrResult(null);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `${API_URL}/api/cout-reel-hec/factures/ocr`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      const extracted = response.data.extracted_data;
      setOcrResult(extracted);
      
      // Pre-fill the invoice form
      setEditingInvoice({
        fournisseur: extracted.fournisseur || "",
        numero_facture: extracted.numero_facture || "",
        date_facture: extracted.date_facture || new Date().toISOString().split("T")[0],
        montant_total: extracted.montant_total || 0,
        items: (extracted.items || []).map(item => ({
          ...item,
          category: item.category || "Divers"
        })),
        notes: ""
      });
      
      setShowInvoiceDialog(true);
      toast.success("Facture analysée avec succès !");
    } catch (error) {
      console.error("OCR error:", error);
      toast.error("Erreur lors de l'analyse de la facture");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  // Save invoice
  const handleSaveInvoice = async () => {
    if (!editingInvoice?.fournisseur || !editingInvoice?.montant_total) {
      toast.error("Veuillez remplir les champs obligatoires");
      return;
    }

    setSavingInvoice(true);
    try {
      if (editingInvoice.id) {
        await axios.put(
          `${API_URL}/api/cout-reel-hec/factures/${editingInvoice.id}`,
          editingInvoice,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          `${API_URL}/api/cout-reel-hec/factures`,
          editingInvoice,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      
      toast.success("Facture enregistrée");
      setShowInvoiceDialog(false);
      setEditingInvoice(null);
      setOcrResult(null);
      fetchData();
    } catch (error) {
      toast.error("Erreur lors de l'enregistrement");
    } finally {
      setSavingInvoice(false);
    }
  };

  // Delete invoice
  const handleDeleteInvoice = async (invoiceId) => {
    if (!window.confirm("Supprimer cette facture ?")) return;

    try {
      await axios.delete(`${API_URL}/api/cout-reel-hec/factures/${invoiceId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Facture supprimée");
      fetchData();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    }
  };

  // Save acompte
  const handleSaveAcompte = async () => {
    if (!newAcompte.montant || !newAcompte.date_paiement) {
      toast.error("Veuillez remplir les champs obligatoires");
      return;
    }

    setSavingAcompte(true);
    try {
      await axios.post(
        `${API_URL}/api/cout-reel-hec/acomptes`,
        { ...newAcompte, montant: parseFloat(newAcompte.montant) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success("Acompte enregistré");
      setShowAcompteDialog(false);
      setNewAcompte({ montant: "", date_paiement: "", notes: "" });
      fetchData();
    } catch (error) {
      toast.error("Erreur lors de l'enregistrement");
    } finally {
      setSavingAcompte(false);
    }
  };

  // Delete acompte
  const handleDeleteAcompte = async (acompteId) => {
    if (!window.confirm("Supprimer cet acompte ?")) return;

    try {
      await axios.delete(`${API_URL}/api/cout-reel-hec/acomptes/${acompteId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Acompte supprimé");
      fetchData();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    }
  };

  // Save ventes
  const handleSaveVentes = async () => {
    setSavingVentes(true);
    try {
      await axios.put(
        `${API_URL}/api/cout-reel-hec/ventes`,
        ventes,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Ventes enregistrées");
      fetchData();
    } catch (error) {
      toast.error("Erreur lors de l'enregistrement");
    } finally {
      setSavingVentes(false);
    }
  };

  // Add item to invoice
  const addInvoiceItem = () => {
    setEditingInvoice({
      ...editingInvoice,
      items: [
        ...(editingInvoice.items || []),
        { description: "", quantity: 1, unite: "unité", unit_price: 0, total: 0, category: "Divers" }
      ]
    });
  };

  // Update item
  const updateInvoiceItem = (index, field, value) => {
    const newItems = [...(editingInvoice.items || [])];
    newItems[index] = { ...newItems[index], [field]: value };
    
    // Auto-calculate total
    if (field === "quantity" || field === "unit_price") {
      const qty = parseFloat(newItems[index].quantity) || 0;
      const price = parseFloat(newItems[index].unit_price) || 0;
      newItems[index].total = qty * price;
    }
    
    setEditingInvoice({ ...editingInvoice, items: newItems });
  };

  // Remove item
  const removeInvoiceItem = (index) => {
    const newItems = [...(editingInvoice.items || [])];
    newItems.splice(index, 1);
    setEditingInvoice({ ...editingInvoice, items: newItems });
  };

  // Open manual invoice
  const openNewInvoice = () => {
    setEditingInvoice({
      fournisseur: "",
      numero_facture: "",
      date_facture: new Date().toISOString().split("T")[0],
      montant_total: 0,
      items: [],
      notes: ""
    });
    setOcrResult(null);
    setShowInvoiceDialog(true);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  const synthese = data?.synthese || {};

  return (
    <div className="space-y-6" data-testid="cout-reel-hec-page">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
            <Calculator className="w-7 h-7 text-primary" />
            Coût Réel HEC
          </h1>
          <p className="text-gray-500">Suivi des coûts, ventes et bénéfices</p>
        </div>
        <div className="flex gap-2">
          <div className="relative">
            <input
              type="file"
              accept="image/*,.pdf"
              onChange={handleFileUpload}
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              disabled={uploading}
            />
            <Button variant="outline" disabled={uploading}>
              {uploading ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <Upload className="w-4 h-4 mr-2" />
              )}
              Importer Facture (OCR)
            </Button>
          </div>
          <Button onClick={openNewInvoice}>
            <Plus className="w-4 h-4 mr-2" />
            Saisie Manuelle
          </Button>
          <Button variant="outline" onClick={handleExportComplet} className="bg-emerald-50 border-emerald-300 text-emerald-700 hover:bg-emerald-100">
            <Download className="w-4 h-4 mr-2" />
            Export Complet
          </Button>
        </div>
      </div>

      {/* Synthèse Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Total Coûts */}
        <Card className="bg-gradient-to-br from-red-50 to-red-100 border-red-200">
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-red-600 font-medium">Total Coûts (Factures)</p>
                <p className="text-2xl font-bold text-red-800">{synthese.total_factures?.toLocaleString("fr-FR")} €</p>
              </div>
              <Receipt className="w-10 h-10 text-red-400" />
            </div>
          </CardContent>
        </Card>

        {/* Total Ventes */}
        <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-green-600 font-medium">Total Ventes</p>
                <p className="text-2xl font-bold text-green-800">{synthese.total_ventes?.toLocaleString("fr-FR")} €</p>
                {(synthese.total_montants_perso > 0 || synthese.total_ventes_manuelles > 0) && (
                  <p className="text-xs text-green-600 mt-1">
                    {synthese.total_ventes_manuelles > 0 && `Manuelles: ${synthese.total_ventes_manuelles?.toLocaleString("fr-FR")}€`}
                    {synthese.total_ventes_manuelles > 0 && synthese.total_montants_perso > 0 && " + "}
                    {synthese.total_montants_perso > 0 && `Perso: ${synthese.total_montants_perso?.toLocaleString("fr-FR")}€`}
                  </p>
                )}
              </div>
              <TrendingUp className="w-10 h-10 text-green-400" />
            </div>
          </CardContent>
        </Card>

        {/* Commission HEC */}
        <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-blue-600 font-medium">Commission HEC (10% HT)</p>
                <p className="text-2xl font-bold text-blue-800">{synthese.commission_hec?.toLocaleString("fr-FR")} €</p>
              </div>
              <Percent className="w-10 h-10 text-blue-400" />
            </div>
          </CardContent>
        </Card>

        {/* Bénéfice Net */}
        <Card className={`bg-gradient-to-br ${synthese.benefice_net >= 0 ? 'from-emerald-50 to-emerald-100 border-emerald-200' : 'from-orange-50 to-orange-100 border-orange-200'}`}>
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className={`text-sm font-medium ${synthese.benefice_net >= 0 ? 'text-emerald-600' : 'text-orange-600'}`}>Bénéfice Net</p>
                <p className={`text-2xl font-bold ${synthese.benefice_net >= 0 ? 'text-emerald-800' : 'text-orange-800'}`}>
                  {synthese.benefice_net?.toLocaleString("fr-FR")} €
                </p>
              </div>
              {synthese.benefice_net >= 0 ? (
                <PiggyBank className="w-10 h-10 text-emerald-400" />
              ) : (
                <TrendingDown className="w-10 h-10 text-orange-400" />
              )}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Status Paiement */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div>
                <p className="text-sm text-gray-500">Statut paiement fournisseurs</p>
                <div className="flex items-center gap-2 mt-1">
                  {synthese.statut_paiement === "payé" && (
                    <Badge className="bg-green-100 text-green-800 border-green-300">
                      <CheckCircle className="w-3 h-3 mr-1" /> Payé
                    </Badge>
                  )}
                  {synthese.statut_paiement === "partiellement payé" && (
                    <Badge className="bg-yellow-100 text-yellow-800 border-yellow-300">
                      <Clock className="w-3 h-3 mr-1" /> Partiellement payé
                    </Badge>
                  )}
                  {synthese.statut_paiement === "non payé" && (
                    <Badge className="bg-red-100 text-red-800 border-red-300">
                      <AlertCircle className="w-3 h-3 mr-1" /> Non payé
                    </Badge>
                  )}
                </div>
              </div>
              <div className="border-l pl-4">
                <p className="text-sm text-gray-500">Acomptes versés</p>
                <p className="text-lg font-semibold text-gray-800">{synthese.total_acomptes?.toLocaleString("fr-FR")} €</p>
              </div>
              <div className="border-l pl-4">
                <p className="text-sm text-gray-500">Reste à payer</p>
                <p className="text-lg font-semibold text-red-600">{synthese.reste_a_payer?.toLocaleString("fr-FR")} €</p>
              </div>
            </div>
            <Button variant="outline" onClick={() => setShowAcompteDialog(true)}>
              <CreditCard className="w-4 h-4 mr-2" />
              Ajouter un acompte
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-6">
          <TabsTrigger value="synthese">Synthèse</TabsTrigger>
          <TabsTrigger value="synthese-ft" data-testid="tab-synthese-ft">Récap FT</TabsTrigger>
          <TabsTrigger value="factures">Factures ({data?.factures?.length || 0})</TabsTrigger>
          <TabsTrigger value="acomptes">Acomptes ({data?.acomptes?.length || 0})</TabsTrigger>
          <TabsTrigger value="ventes">Ventes</TabsTrigger>
          <TabsTrigger value="mbat" data-testid="tab-mbat">MBAT</TabsTrigger>
        </TabsList>

        {/* Synthèse Tab */}
        <TabsContent value="synthese" className="space-y-4">
          {/* Synthèse Globale Cards */}
          {syntheseData && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-blue-600 font-medium">Coût Total Prévu</p>
                      <p className="text-2xl font-bold text-blue-800">
                        {syntheseData.synthese?.total_cout_prevu?.toLocaleString("fr-FR")} €
                      </p>
                    </div>
                    <Calculator className="w-10 h-10 text-blue-400" />
                  </div>
                </CardContent>
              </Card>

              <Card className={`bg-gradient-to-br ${(syntheseData.synthese?.ecart || 0) > 0 ? 'from-red-50 to-red-100 border-red-200' : 'from-green-50 to-green-100 border-green-200'}`}>
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className={`text-sm font-medium ${(syntheseData.synthese?.ecart || 0) > 0 ? 'text-red-600' : 'text-green-600'}`}>
                        Coût Total Réel
                      </p>
                      <p className={`text-2xl font-bold ${(syntheseData.synthese?.ecart || 0) > 0 ? 'text-red-800' : 'text-green-800'}`}>
                        {syntheseData.synthese?.total_cout_reel?.toLocaleString("fr-FR")} €
                      </p>
                    </div>
                    <Wallet className="w-10 h-10 text-gray-400" />
                  </div>
                </CardContent>
              </Card>

              <Card className={`bg-gradient-to-br ${(syntheseData.synthese?.ecart || 0) > 0 ? 'from-red-50 to-red-100 border-red-200' : 'from-green-50 to-green-100 border-green-200'}`}>
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className={`text-sm font-medium ${(syntheseData.synthese?.ecart || 0) > 0 ? 'text-red-600' : 'text-green-600'}`}>
                        Écart
                      </p>
                      <p className={`text-2xl font-bold ${(syntheseData.synthese?.ecart || 0) > 0 ? 'text-red-800' : 'text-green-800'}`}>
                        {(syntheseData.synthese?.ecart || 0) > 0 ? '+' : ''}{syntheseData.synthese?.ecart?.toLocaleString("fr-FR")} €
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {syntheseData.synthese?.ecart_percent > 0 ? '+' : ''}{syntheseData.synthese?.ecart_percent}%
                      </p>
                    </div>
                    {(syntheseData.synthese?.ecart || 0) > 0 ? (
                      <TrendingUp className="w-10 h-10 text-red-400" />
                    ) : (
                      <TrendingDown className="w-10 h-10 text-green-400" />
                    )}
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-purple-600 font-medium">Staff (Heures Réelles)</p>
                      <p className="text-2xl font-bold text-purple-800">
                        {syntheseData.staff?.heures_reelles || 0}h
                      </p>
                      <p className="text-xs text-muted-foreground">
                        Prévu: {syntheseData.staff?.heures_prevues || 0}h
                      </p>
                    </div>
                    <Users className="w-10 h-10 text-purple-400" />
                  </div>
                </CardContent>
              </Card>
            </div>
          )}

          {/* Breakdown Chart */}
          {syntheseData && (
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <BarChart3 className="w-5 h-5 text-primary" />
                  Répartition des Coûts Réels
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {syntheseData.breakdown?.map((item, idx) => (
                    <div key={idx} className="flex items-center justify-between py-3 border-b last:border-0">
                      <div className="flex items-center gap-3">
                        {item.type === 'factures' && <Receipt className="w-5 h-5 text-blue-500" />}
                        {item.type === 'staff' && <Users className="w-5 h-5 text-purple-500" />}
                        {item.type === 'depenses' && <Wallet className="w-5 h-5 text-orange-500" />}
                        {item.type === 'jetons' && <Ticket className="w-5 h-5 text-red-500" />}
                        <span className="font-medium">{item.label}</span>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="w-40 bg-gray-200 rounded-full h-2">
                          <div 
                            className={`h-2 rounded-full ${
                              item.type === 'factures' ? 'bg-blue-500' :
                              item.type === 'staff' ? 'bg-purple-500' :
                              item.type === 'depenses' ? 'bg-orange-500' : 'bg-red-500'
                            }`}
                            style={{ width: `${Math.min(100, (item.montant / (syntheseData.synthese?.total_cout_reel || 1)) * 100)}%` }}
                          />
                        </div>
                        <span className="font-semibold w-24 text-right">{item.montant?.toLocaleString("fr-FR")} €</span>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          )}

          {/* Staff Summary */}
          <Card>
            <CardHeader className="flex flex-row items-center justify-between">
              <CardTitle className="flex items-center gap-2">
                <Users className="w-5 h-5 text-purple-600" />
                Staff - Heures Prévues & Réelles
              </CardTitle>
              <div className="flex gap-2">
                <Button 
                  variant="outline" 
                  size="sm"
                  onClick={() => { fetchStaffFromPlanning(); setShowImportStaffDialog(true); }}
                  disabled={loadingPlanningStaff}
                  data-testid="btn-import-staff-planning"
                >
                  {loadingPlanningStaff ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <Download className="w-4 h-4 mr-2" />
                  )}
                  Importer du Planning HEC
                </Button>
                <Button onClick={() => setShowStaffDialog(true)} size="sm">
                  <Plus className="w-4 h-4 mr-2" />
                  Saisie manuelle
                </Button>
                {staffData?.entries?.length > 0 && (
                  <Button variant="outline" size="sm" onClick={handleClearAllStaff} className="text-red-600">
                    <Trash2 className="w-4 h-4 mr-2" />
                    Tout effacer
                  </Button>
                )}
              </div>
            </CardHeader>
            <CardContent>
              {staffData?.entries?.length > 0 ? (
                <>
                  <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-4">
                    <div className="p-3 bg-purple-50 rounded-lg">
                      <p className="text-sm text-purple-600">H. Prévues</p>
                      <p className="text-xl font-bold text-purple-800">{staffData.summary?.total_heures_prevues}h</p>
                    </div>
                    <div className="p-3 bg-purple-50 rounded-lg">
                      <p className="text-sm text-purple-600">H. Réelles</p>
                      <p className="text-xl font-bold text-purple-800">{staffData.summary?.total_heures_reelles}h</p>
                    </div>
                    <div className="p-3 bg-blue-50 rounded-lg">
                      <p className="text-sm text-blue-600">Coût Prévu</p>
                      <p className="text-xl font-bold text-blue-800">{staffData.summary?.total_cout_prevu?.toLocaleString("fr-FR")} €</p>
                    </div>
                    <div className={`p-3 rounded-lg ${staffData.summary?.ecart_cout > 0 ? 'bg-red-50' : 'bg-green-50'}`}>
                      <p className={`text-sm ${staffData.summary?.ecart_cout > 0 ? 'text-red-600' : 'text-green-600'}`}>Coût Réel</p>
                      <p className={`text-xl font-bold ${staffData.summary?.ecart_cout > 0 ? 'text-red-800' : 'text-green-800'}`}>
                        {staffData.summary?.total_cout_reel?.toLocaleString("fr-FR")} €
                      </p>
                    </div>
                    <div className={`p-3 rounded-lg ${staffData.summary?.ecart_cout > 0 ? 'bg-red-50' : staffData.summary?.ecart_cout < 0 ? 'bg-green-50' : 'bg-gray-50'}`}>
                      <p className="text-sm text-gray-600">Écart</p>
                      <p className={`text-xl font-bold ${staffData.summary?.ecart_cout > 0 ? 'text-red-800' : staffData.summary?.ecart_cout < 0 ? 'text-green-800' : 'text-gray-800'}`}>
                        {staffData.summary?.ecart_cout > 0 ? '+' : ''}{staffData.summary?.ecart_cout?.toLocaleString("fr-FR")} €
                      </p>
                    </div>
                  </div>
                  
                  {/* Summary by person */}
                  {staffData.by_person && Object.keys(staffData.by_person).length > 0 && (
                    <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                      <h4 className="font-semibold mb-3 text-sm text-gray-700">Récapitulatif par personne</h4>
                      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                        {Object.entries(staffData.by_person).map(([nom, data]) => (
                          <div key={nom} className="bg-white p-3 rounded border">
                            <p className="font-medium text-sm truncate">{nom}</p>
                            <p className="text-xs text-gray-500">{data.role}</p>
                            <div className="flex justify-between mt-1 text-xs">
                              <span>Prévu: {data.heures_prevues}h</span>
                              <span className="font-semibold">Réel: {data.heures_reelles}h</span>
                            </div>
                            <p className={`text-sm font-bold mt-1 ${data.cout_reel > data.cout_prevu ? 'text-red-600' : 'text-green-600'}`}>
                              {data.cout_reel?.toLocaleString("fr-FR")} €
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Nom</TableHead>
                        <TableHead>Rôle</TableHead>
                        <TableHead>Jour</TableHead>
                        <TableHead className="text-right">H. Prévues</TableHead>
                        <TableHead className="text-right">H. Réelles</TableHead>
                        <TableHead className="text-right">Taux/h</TableHead>
                        <TableHead className="text-right">Coût Prévu</TableHead>
                        <TableHead className="text-right">Coût Réel</TableHead>
                        <TableHead></TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {staffData.entries.map((entry, idx) => (
                        <TableRow key={idx} className={entry.benevole ? 'bg-gray-50' : ''}>
                          <TableCell className="font-medium">
                            {entry.nom}
                            {entry.benevole && <Badge className="ml-2 bg-green-100 text-green-700">Bénévole</Badge>}
                          </TableCell>
                          <TableCell>
                            <Badge variant="outline">{entry.role}</Badge>
                          </TableCell>
                          <TableCell>{entry.date}</TableCell>
                          <TableCell className="text-right">{entry.heures_prevues}h</TableCell>
                          <TableCell className="text-right font-semibold">{entry.heures_reelles}h</TableCell>
                          <TableCell className="text-right text-muted-foreground">
                            {entry.benevole ? '-' : `${entry.taux_horaire}€`}
                          </TableCell>
                          <TableCell className="text-right text-muted-foreground">
                            {entry.benevole ? '-' : `${entry.cout_prevu?.toFixed(2)} €`}
                          </TableCell>
                          <TableCell className="text-right font-semibold">
                            {entry.benevole ? '-' : `${entry.cout_reel?.toFixed(2)} €`}
                          </TableCell>
                          <TableCell>
                            <Button variant="ghost" size="sm" onClick={() => handleDeleteStaff(entry.id)}>
                              <Trash2 className="w-4 h-4 text-red-500" />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </>
              ) : (
                <div className="text-center py-8 text-muted-foreground">
                  <Users className="w-12 h-12 mx-auto mb-4 opacity-50" />
                  <p className="mb-4">Aucune entrée staff enregistrée</p>
                  <div className="flex gap-4 justify-center">
                    <Button 
                      variant="outline"
                      onClick={() => { fetchStaffFromPlanning(); setShowImportStaffDialog(true); }}
                      disabled={loadingPlanningStaff}
                    >
                      {loadingPlanningStaff ? (
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      ) : (
                        <Download className="w-4 h-4 mr-2" />
                      )}
                      Importer du Planning HEC
                    </Button>
                    <Button onClick={() => setShowStaffDialog(true)}>
                      <Plus className="w-4 h-4 mr-2" />
                      Saisie manuelle
                    </Button>
                  </div>
                </div>
              )}
            </CardContent>
          </Card>

          {/* Dépenses Manuelles */}
          <Card>
            <CardHeader className="flex flex-row items-center justify-between">
              <CardTitle className="flex items-center gap-2">
                <Wallet className="w-5 h-5 text-orange-600" />
                Dépenses Manuelles
              </CardTitle>
              <Button onClick={() => setShowDepenseDialog(true)} size="sm">
                <Plus className="w-4 h-4 mr-2" />
                Ajouter Dépense
              </Button>
            </CardHeader>
            <CardContent>
              {depensesData?.entries?.length > 0 ? (
                <>
                  <div className="flex flex-wrap gap-3 mb-4">
                    {Object.entries(depensesData.by_category || {}).map(([cat, total]) => (
                      <Badge key={cat} variant="outline" className="py-2 px-3">
                        {cat}: {total.toLocaleString("fr-FR")} €
                      </Badge>
                    ))}
                    <Badge className="py-2 px-3 bg-orange-500">
                      Total: {depensesData.total?.toLocaleString("fr-FR")} €
                    </Badge>
                  </div>
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Date</TableHead>
                        <TableHead>Description</TableHead>
                        <TableHead>Catégorie</TableHead>
                        <TableHead>Fournisseur</TableHead>
                        <TableHead className="text-right">Montant</TableHead>
                        <TableHead></TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {depensesData.entries.map((entry, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{new Date(entry.date).toLocaleDateString("fr-FR")}</TableCell>
                          <TableCell className="font-medium">{entry.description}</TableCell>
                          <TableCell>
                            <Badge variant="outline">{entry.categorie}</Badge>
                          </TableCell>
                          <TableCell className="text-muted-foreground">{entry.fournisseur}</TableCell>
                          <TableCell className="text-right font-semibold">{entry.montant?.toLocaleString("fr-FR")} €</TableCell>
                          <TableCell>
                            <Button variant="ghost" size="sm" onClick={() => handleDeleteDepense(entry.id)}>
                              <Trash2 className="w-4 h-4 text-red-500" />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </>
              ) : (
                <div className="text-center py-8 text-muted-foreground">
                  <Wallet className="w-12 h-12 mx-auto mb-4 opacity-50" />
                  <p>Aucune dépense manuelle</p>
                  <Button className="mt-4" onClick={() => setShowDepenseDialog(true)}>
                    <Plus className="w-4 h-4 mr-2" />
                    Ajouter une dépense
                  </Button>
                </div>
              )}
            </CardContent>
          </Card>

          {/* Ancien calcul du bénéfice */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <BarChart3 className="w-5 h-5 text-primary" />
                Répartition des coûts par catégorie (Factures)
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {CATEGORIES.map((cat) => (
                  <div key={cat} className={`p-4 rounded-lg border ${CATEGORY_COLORS[cat]}`}>
                    <p className="text-sm font-medium">{cat}</p>
                    <p className="text-xl font-bold mt-1">
                      {(synthese.categories?.[cat] || 0).toLocaleString("fr-FR")} €
                    </p>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Synthèse par Food Truck Tab */}
        <TabsContent value="synthese-ft" className="space-y-4">
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle className="flex items-center gap-2">
                    <UtensilsCrossed className="w-5 h-5 text-primary" />
                    Récapitulatif par Food Truck
                  </CardTitle>
                  <p className="text-sm text-muted-foreground mt-1">
                    Montant total dû à chaque food truck (ventes - commission HEC + jetons surplus + Croix Blanche)
                  </p>
                </div>
                {syntheseFTData?.food_trucks?.length > 0 && (
                  <Button
                    variant="outline"
                    size="sm"
                    className="gap-2"
                    onClick={async () => {
                      try {
                        const token = localStorage.getItem("token");
                        const response = await fetch(`${API_URL}/api/cout-reel-hec/synthese-food-trucks/export-excel`, {
                          headers: { Authorization: `Bearer ${token}` }
                        });
                        if (!response.ok) throw new Error("Erreur export");
                        const blob = await response.blob();
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = `recap_food_trucks_${new Date().toISOString().slice(0, 10)}.xlsx`;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                        toast.success("Export Excel téléchargé");
                      } catch (err) {
                        toast.error("Erreur lors de l'export Excel");
                      }
                    }}
                    data-testid="export-recap-ft-excel"
                  >
                    <FileSpreadsheet className="w-4 h-4" />
                    Export Excel
                  </Button>
                )}
              </div>
            </CardHeader>
            <CardContent>
              {!syntheseFTData?.food_trucks?.length ? (
                <div className="text-center py-12 text-muted-foreground">
                  <Building2 className="w-12 h-12 mx-auto mb-4 opacity-50" />
                  <p>Aucune donnée disponible</p>
                  <p className="text-sm">Importez d'abord des données MBAT</p>
                </div>
              ) : (
                <>
                  {/* Summary Cards */}
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                    <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
                      <CardContent className="pt-4 pb-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-xs text-blue-600 font-medium">Ventes HT</p>
                            <p className="text-xl font-bold text-blue-800">
                              {syntheseFTData.totals?.ventes_ht?.toLocaleString("fr-FR")} €
                            </p>
                          </div>
                          <Euro className="w-8 h-8 text-blue-400" />
                        </div>
                      </CardContent>
                    </Card>
                    
                    <Card className="bg-gradient-to-br from-red-50 to-red-100 border-red-200">
                      <CardContent className="pt-4 pb-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-xs text-red-600 font-medium">Commission HEC (10%)</p>
                            <p className="text-xl font-bold text-red-800">
                              -{syntheseFTData.totals?.commission_hec?.toLocaleString("fr-FR")} €
                            </p>
                          </div>
                          <Percent className="w-8 h-8 text-red-400" />
                        </div>
                      </CardContent>
                    </Card>
                    
                    <Card className="bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200">
                      <CardContent className="pt-4 pb-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-xs text-amber-600 font-medium">Jetons Surplus</p>
                            <p className="text-xl font-bold text-amber-800">
                              +{syntheseFTData.totals?.jetons_montant?.toLocaleString("fr-FR")} €
                            </p>
                          </div>
                          <Ticket className="w-8 h-8 text-amber-400" />
                        </div>
                      </CardContent>
                    </Card>
                    
                    <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
                      <CardContent className="pt-4 pb-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-xs text-green-600 font-medium">Total à Payer</p>
                            <p className="text-xl font-bold text-green-800">
                              {syntheseFTData.totals?.total_a_payer?.toLocaleString("fr-FR")} €
                            </p>
                          </div>
                          <Wallet className="w-8 h-8 text-green-400" />
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                  
                  {/* Food Trucks Table */}
                  <div className="border rounded-lg overflow-x-auto">
                    <Table>
                      <TableHeader>
                        <TableRow className="bg-muted/50">
                          <TableHead>Food Truck</TableHead>
                          <TableHead className="text-right">Ventes HT</TableHead>
                          <TableHead className="text-right">Commission HEC</TableHead>
                          <TableHead className="text-right">Net Ventes</TableHead>
                          <TableHead className="text-center">Jetons</TableHead>
                          <TableHead className="text-right">Jetons € HT</TableHead>
                          <TableHead className="text-center">Croix Blanche</TableHead>
                          <TableHead className="text-right">CB € HT</TableHead>
                          <TableHead className="text-right font-bold">Total à Payer</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {syntheseFTData.food_trucks.map((ft, index) => (
                          <TableRow key={index}>
                            <TableCell className="font-medium">{ft.food_truck}</TableCell>
                            <TableCell className="text-right">{ft.ventes_ht?.toLocaleString("fr-FR")} €</TableCell>
                            <TableCell className="text-right text-red-600">-{ft.commission_hec?.toLocaleString("fr-FR")} €</TableCell>
                            <TableCell className="text-right">{ft.net_ventes?.toLocaleString("fr-FR")} €</TableCell>
                            <TableCell className="text-center">
                              <span className="text-xs">
                                {ft.jetons_count} / {ft.jetons_gratuits} gratuits
                                {ft.jetons_surplus > 0 && (
                                  <Badge className="ml-1 bg-amber-100 text-amber-800">+{ft.jetons_surplus}</Badge>
                                )}
                              </span>
                            </TableCell>
                            <TableCell className="text-right text-amber-600">
                              {ft.jetons_montant > 0 ? `+${ft.jetons_montant?.toLocaleString("fr-FR")} €` : "0 €"}
                            </TableCell>
                            <TableCell className="text-center">
                              <span className="text-xs">
                                {ft.croix_blanche_count || 0} / {ft.croix_blanche_gratuits || 0} gratuits
                                {ft.croix_blanche_surplus > 0 && (
                                  <Badge className="ml-1 bg-purple-100 text-purple-800">+{ft.croix_blanche_surplus}</Badge>
                                )}
                              </span>
                            </TableCell>
                            <TableCell className="text-right text-purple-600">
                              {ft.croix_blanche_montant > 0 ? `+${ft.croix_blanche_montant?.toLocaleString("fr-FR")} €` : "0 €"}
                            </TableCell>
                            <TableCell className="text-right font-bold text-green-700">
                              {ft.total_a_payer?.toLocaleString("fr-FR")} €
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <tfoot>
                        <TableRow className="bg-green-50 font-bold">
                          <TableCell>TOTAL</TableCell>
                          <TableCell className="text-right">{syntheseFTData.totals?.ventes_ht?.toLocaleString("fr-FR")} €</TableCell>
                          <TableCell className="text-right text-red-600">-{syntheseFTData.totals?.commission_hec?.toLocaleString("fr-FR")} €</TableCell>
                          <TableCell className="text-right">{syntheseFTData.totals?.net_ventes?.toLocaleString("fr-FR")} €</TableCell>
                          <TableCell className="text-center">{syntheseFTData.totals?.jetons_count}</TableCell>
                          <TableCell className="text-right text-amber-600">+{syntheseFTData.totals?.jetons_montant?.toLocaleString("fr-FR")} €</TableCell>
                          <TableCell className="text-center">{syntheseFTData.totals?.croix_blanche_count || 0}</TableCell>
                          <TableCell className="text-right text-purple-600">+{syntheseFTData.totals?.croix_blanche_montant?.toLocaleString("fr-FR")} €</TableCell>
                          <TableCell className="text-right text-green-700 text-lg">{syntheseFTData.totals?.total_a_payer?.toLocaleString("fr-FR")} €</TableCell>
                        </TableRow>
                      </tfoot>
                    </Table>
                  </div>
                  
                  {/* Legend */}
                  <div className="mt-4 p-3 bg-muted/30 rounded-lg text-xs text-muted-foreground">
                    <p><strong>Calcul :</strong> Total à Payer = (Ventes HT - Commission HEC 10%) + Jetons Surplus × {syntheseFTData.jeton_price_ht || 10}€ HT + Croix Blanche Surplus × {syntheseFTData.jeton_price_ht || 10}€ HT</p>
                    <p className="mt-1"><strong>Jetons/CB gratuits :</strong> 6 par service Midi + 8 par service Soir (sauf samedi)</p>
                    <p className="mt-1"><strong>Prix jeton :</strong> {syntheseFTData.jeton_price_ht || 10}€ HT ({syntheseFTData.jeton_price_ttc || 11}€ TTC)</p>
                  </div>
                </>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Factures Tab */}
        <TabsContent value="factures">
          <Card>
            <CardContent className="pt-6">
              {data?.factures?.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                  <Receipt className="w-16 h-16 mx-auto mb-4 opacity-30" />
                  <p>Aucune facture enregistrée</p>
                  <p className="text-sm mt-2">Importez une facture avec OCR ou saisissez-la manuellement</p>
                </div>
              ) : (
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Date</TableHead>
                      <TableHead>Fournisseur</TableHead>
                      <TableHead>N° Facture</TableHead>
                      <TableHead>Catégories</TableHead>
                      <TableHead className="text-right">Montant</TableHead>
                      <TableHead className="text-center">Actions</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {data?.factures?.map((facture) => (
                      <TableRow key={facture.id}>
                        <TableCell>{new Date(facture.date_facture).toLocaleDateString("fr-FR")}</TableCell>
                        <TableCell className="font-medium">{facture.fournisseur}</TableCell>
                        <TableCell>{facture.numero_facture || "-"}</TableCell>
                        <TableCell>
                          <div className="flex flex-wrap gap-1">
                            {[...new Set(facture.items?.map(i => i.category) || [])].map((cat) => (
                              <Badge key={cat} variant="outline" className={`text-xs ${CATEGORY_COLORS[cat]}`}>
                                {cat}
                              </Badge>
                            ))}
                          </div>
                        </TableCell>
                        <TableCell className="text-right font-semibold">{facture.montant_total?.toLocaleString("fr-FR")} €</TableCell>
                        <TableCell className="text-center">
                          <div className="flex justify-center gap-1">
                            <Button
                              size="sm"
                              variant="ghost"
                              onClick={() => {
                                setEditingInvoice(facture);
                                setShowInvoiceDialog(true);
                              }}
                            >
                              <Edit className="w-4 h-4" />
                            </Button>
                            <Button
                              size="sm"
                              variant="ghost"
                              className="text-red-500"
                              onClick={() => handleDeleteInvoice(facture.id)}
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Acomptes Tab */}
        <TabsContent value="acomptes">
          <Card>
            <CardContent className="pt-6">
              {data?.acomptes?.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                  <CreditCard className="w-16 h-16 mx-auto mb-4 opacity-30" />
                  <p>Aucun acompte enregistré</p>
                </div>
              ) : (
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Date</TableHead>
                      <TableHead className="text-right">Montant</TableHead>
                      <TableHead>Notes</TableHead>
                      <TableHead className="text-center">Actions</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {data?.acomptes?.map((acompte) => (
                      <TableRow key={acompte.id}>
                        <TableCell>{new Date(acompte.date_paiement).toLocaleDateString("fr-FR")}</TableCell>
                        <TableCell className="text-right font-semibold text-green-600">
                          {acompte.montant?.toLocaleString("fr-FR")} €
                        </TableCell>
                        <TableCell className="text-gray-500">{acompte.notes || "-"}</TableCell>
                        <TableCell className="text-center">
                          <Button
                            size="sm"
                            variant="ghost"
                            className="text-red-500"
                            onClick={() => handleDeleteAcompte(acompte.id)}
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Ventes Tab */}
        <TabsContent value="ventes">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Banknote className="w-5 h-5 text-green-600" />
                Résultat des ventes
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                <div>
                  <Label className="text-amber-700">Bière (€)</Label>
                  <Input
                    type="number"
                    value={ventes.biere}
                    onChange={(e) => setVentes({ ...ventes, biere: parseFloat(e.target.value) || 0 })}
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label className="text-orange-700">Cidre (€)</Label>
                  <Input
                    type="number"
                    value={ventes.cidre}
                    onChange={(e) => setVentes({ ...ventes, cidre: parseFloat(e.target.value) || 0 })}
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label className="text-blue-700">Soft (€)</Label>
                  <Input
                    type="number"
                    value={ventes.soft}
                    onChange={(e) => setVentes({ ...ventes, soft: parseFloat(e.target.value) || 0 })}
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label className="text-purple-700">Cocktail (€)</Label>
                  <Input
                    type="number"
                    value={ventes.cocktail}
                    onChange={(e) => setVentes({ ...ventes, cocktail: parseFloat(e.target.value) || 0 })}
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label className="text-yellow-700">Vin Blanc (€)</Label>
                  <Input
                    type="number"
                    value={ventes.vin_blanc}
                    onChange={(e) => setVentes({ ...ventes, vin_blanc: parseFloat(e.target.value) || 0 })}
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label className="text-red-700">Vin Rouge (€)</Label>
                  <Input
                    type="number"
                    value={ventes.vin_rouge}
                    onChange={(e) => setVentes({ ...ventes, vin_rouge: parseFloat(e.target.value) || 0 })}
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label className="text-pink-700">Vin Rosé (€)</Label>
                  <Input
                    type="number"
                    value={ventes.vin_rose}
                    onChange={(e) => setVentes({ ...ventes, vin_rose: parseFloat(e.target.value) || 0 })}
                    className="mt-1"
                  />
                </div>
              </div>

              <div className="flex justify-between items-center mt-6 pt-4 border-t">
                <div>
                  <p className="text-sm text-gray-500">Total des ventes manuelles</p>
                  <p className="text-2xl font-bold text-green-600">
                    {((ventes.biere || 0) + (ventes.cidre || 0) + (ventes.soft || 0) + (ventes.cocktail || 0) + (ventes.vin_blanc || 0) + (ventes.vin_rouge || 0) + (ventes.vin_rose || 0)).toLocaleString("fr-FR")} €
                  </p>
                </div>
                <Button onClick={handleSaveVentes} disabled={savingVentes}>
                  {savingVentes ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <Save className="w-4 h-4 mr-2" />
                  )}
                  Enregistrer les ventes
                </Button>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* MBAT Tab */}
        <TabsContent value="mbat" className="space-y-4">
          {/* MBAT Header */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <h3 className="text-lg font-semibold flex items-center gap-2">
                <CreditCard className="w-5 h-5 text-primary" />
                Import MBAT - Règlement
              </h3>
              <p className="text-sm text-muted-foreground">
                Analysez les transactions par food truck et articles
              </p>
            </div>
            <div className="flex items-center gap-2">
              {/* Rename Food Truck Button */}
              {mbatData && (
                <Button 
                  variant="outline" 
                  className="border-blue-300 text-blue-600 hover:bg-blue-50"
                  onClick={() => setShowRenameDialog(true)}
                  data-testid="btn-rename-foodtruck"
                >
                  <Edit className="w-4 h-4 mr-2" />
                  Renommer Food Truck
                </Button>
              )}
              
              {/* Delete MBAT Button */}
              {mbatData && (
                <Button 
                  variant="outline" 
                  className="border-red-300 text-red-600 hover:bg-red-50"
                  onClick={() => setShowDeleteMbatDialog(true)}
                  data-testid="btn-delete-mbat"
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Supprimer données MBAT
                </Button>
              )}
              
              {/* Upload MBAT Button */}
              <div className="relative">
                <input
                  type="file"
                  accept=".csv"
                  onChange={handleMbatUpload}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  disabled={uploadingMbat}
                />
                <Button variant="outline" disabled={uploadingMbat} data-testid="btn-upload-mbat">
                  {uploadingMbat ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <Upload className="w-4 h-4 mr-2" />
                  )}
                  Importer fichier MBAT (.csv)
                </Button>
              </div>
            </div>
          </div>

          {/* Delete MBAT Confirmation Dialog */}
          <Dialog open={showDeleteMbatDialog} onOpenChange={setShowDeleteMbatDialog}>
            <DialogContent>
              <DialogHeader>
                <DialogTitle className="flex items-center gap-2 text-red-600">
                  <AlertTriangle className="w-5 h-5" />
                  Supprimer les données MBAT
                </DialogTitle>
              </DialogHeader>
              <div className="py-4">
                <p className="text-gray-700 mb-4">
                  Êtes-vous sûr de vouloir supprimer <strong>toutes les données MBAT</strong> importées ?
                </p>
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-800">
                  <strong>⚠️ Attention :</strong> Cette action supprimera :
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Toutes les transactions MBAT</li>
                    <li>Les données Food Trucks associées</li>
                    <li>Les articles et catégories</li>
                    <li>Les montants personnalisés</li>
                  </ul>
                </div>
              </div>
              <div className="flex justify-end gap-2">
                <Button variant="outline" onClick={() => setShowDeleteMbatDialog(false)}>
                  Annuler
                </Button>
                <Button 
                  variant="destructive" 
                  onClick={handleDeleteAllMbat}
                  disabled={deletingMbat}
                >
                  {deletingMbat ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <Trash2 className="w-4 h-4 mr-2" />
                  )}
                  Confirmer la suppression
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          {/* Rename Food Truck Dialog */}
          <Dialog open={showRenameDialog} onOpenChange={setShowRenameDialog}>
            <DialogContent>
              <DialogHeader>
                <DialogTitle className="flex items-center gap-2">
                  <Edit className="w-5 h-5 text-blue-600" />
                  Renommer un Food Truck
                </DialogTitle>
              </DialogHeader>
              <div className="py-4 space-y-4">
                <p className="text-sm text-muted-foreground">
                  Corrigez le nom d'un food truck mal orthographié dans les données MBAT.
                </p>
                
                <div className="space-y-3">
                  <div>
                    <Label>Nom actuel (à corriger)</Label>
                    <Select
                      value={renameData.old_name}
                      onValueChange={(value) => setRenameData({ ...renameData, old_name: value })}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Sélectionner le nom à corriger" />
                      </SelectTrigger>
                      <SelectContent>
                        {mbatData?.food_trucks?.map((ft, i) => (
                          <SelectItem key={i} value={ft.nom}>
                            {ft.nom} ({ft.transactions} transactions)
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  
                  <div>
                    <Label>Nouveau nom (correct)</Label>
                    <Input
                      value={renameData.new_name}
                      onChange={(e) => setRenameData({ ...renameData, new_name: e.target.value })}
                      placeholder="Ex: Pizza Toccata"
                    />
                  </div>
                </div>
                
                {renameData.old_name && renameData.new_name && (
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm text-blue-800">
                    <strong>Aperçu :</strong> "{renameData.old_name}" → "{renameData.new_name}"
                  </div>
                )}
              </div>
              <DialogFooter>
                <Button variant="outline" onClick={() => {
                  setShowRenameDialog(false);
                  setRenameData({ old_name: "", new_name: "" });
                }}>
                  Annuler
                </Button>
                <Button 
                  onClick={handleRenameFoodTruck}
                  disabled={savingRename || !renameData.old_name || !renameData.new_name}
                >
                  {savingRename ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : (
                    <Save className="w-4 h-4 mr-2" />
                  )}
                  Renommer
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>

          {/* MBAT Summary Cards */}
          {mbatData && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
              <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-blue-600 font-medium">Transactions</p>
                      <p className="text-2xl font-bold text-blue-800">
                        {mbatData.total_transactions?.toLocaleString("fr-FR")}
                      </p>
                    </div>
                    <Receipt className="w-10 h-10 text-blue-400" />
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-green-600 font-medium">Total TTC</p>
                      <p className="text-2xl font-bold text-green-800">
                        {mbatData.total_ttc?.toLocaleString("fr-FR")} €
                      </p>
                    </div>
                    <Euro className="w-10 h-10 text-green-400" />
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-teal-50 to-teal-100 border-teal-200">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-teal-600 font-medium">Total HT Global</p>
                      <p className="text-2xl font-bold text-teal-800">
                        {mbatData.total_ht?.toLocaleString("fr-FR")} €
                      </p>
                    </div>
                    <Calculator className="w-10 h-10 text-teal-400" />
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-indigo-50 to-indigo-100 border-indigo-200" data-testid="card-commission-hec-globale">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-indigo-600 font-medium">Commission HEC (10% HT)</p>
                      <p className="text-2xl font-bold text-indigo-800">
                        {mbatData.commission_hec_globale?.toLocaleString("fr-FR")} €
                      </p>
                    </div>
                    <Percent className="w-10 h-10 text-indigo-400" />
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-purple-600 font-medium">Food Trucks</p>
                      <p className="text-2xl font-bold text-purple-800">
                        {mbatData.food_trucks?.length || 0}
                      </p>
                    </div>
                    <Building2 className="w-10 h-10 text-purple-400" />
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-orange-50 to-orange-100 border-orange-200">
                <CardContent className="pt-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-orange-600 font-medium">Sans catégorie</p>
                      <p className="text-2xl font-bold text-orange-800">
                        {mbatData.transactions_sans_categorie || 0}
                      </p>
                    </div>
                    <AlertCircle className="w-10 h-10 text-orange-400" />
                  </div>
                </CardContent>
              </Card>
            </div>
          )}

          {/* MBAT View Toggle + Export */}
          {mbatData && (
            <div className="flex flex-wrap gap-2 items-center justify-between">
              <div className="flex gap-2 flex-wrap">
                <Button
                  variant={mbatViewMode === "foodtrucks" ? "default" : "outline"}
                  onClick={() => { setMbatViewMode("foodtrucks"); setMbatSelectedFoodTruck(null); }}
                  data-testid="btn-view-foodtrucks"
                  size="sm"
                >
                  <Building2 className="w-4 h-4 mr-2" />
                  Food Trucks
                </Button>
                <Button
                  variant={mbatViewMode === "articles" ? "default" : "outline"}
                  onClick={() => { setMbatViewMode("articles"); setMbatSelectedFoodTruck(null); }}
                  data-testid="btn-view-articles"
                  size="sm"
                >
                  <BarChart3 className="w-4 h-4 mr-2" />
                  Articles
                </Button>
                <Button
                  variant={mbatViewMode === "jetons" ? "default" : "outline"}
                  onClick={() => { setMbatViewMode("jetons"); setMbatSelectedFoodTruck(null); }}
                  data-testid="btn-view-jetons"
                  size="sm"
                >
                  <Ticket className="w-4 h-4 mr-2" />
                  Jetons
                  {jetonsData?.total_excess > 0 && (
                    <Badge className="ml-2 bg-red-500">{jetonsData.total_excess}</Badge>
                  )}
                </Button>
                <Button
                  variant={mbatViewMode === "croixblanche" ? "default" : "outline"}
                  onClick={() => { setMbatViewMode("croixblanche"); setMbatSelectedFoodTruck(null); }}
                  data-testid="btn-view-croixblanche"
                  size="sm"
                >
                  <Cross className="w-4 h-4 mr-2" />
                  Croix Blanche
                </Button>
                <Button
                  variant={mbatViewMode === "unassigned" ? "default" : "outline"}
                  onClick={() => { setMbatViewMode("unassigned"); setMbatSelectedFoodTruck(null); setSelectedTransactions([]); }}
                  data-testid="btn-view-unassigned"
                  size="sm"
                >
                  <CircleHelp className="w-4 h-4 mr-2" />
                  Sans Catégorie
                  {(unassignedData?.total_unassigned || 0) > 0 && (
                    <Badge className="ml-2 bg-orange-500">{unassignedData?.total_unassigned}</Badge>
                  )}
                </Button>
                <Button
                  variant={mbatViewMode === "montants_perso" ? "default" : "outline"}
                  onClick={() => { setMbatViewMode("montants_perso"); setMbatSelectedFoodTruck(null); }}
                  data-testid="btn-view-montants-perso"
                  size="sm"
                >
                  <CreditCard className="w-4 h-4 mr-2" />
                  Montants Perso
                  {(mbatData?.montants_personnalises?.length || 0) > 0 && (
                    <Badge className="ml-2 bg-purple-500">{mbatData?.montants_personnalises?.length}</Badge>
                  )}
                </Button>
              </div>
              <div className="flex gap-2">
                <Button variant="outline" size="sm" onClick={() => handleExportMbat('csv')}>
                  <Download className="w-4 h-4 mr-2" />
                  CSV
                </Button>
                <Button variant="outline" size="sm" onClick={() => handleExportMbat('xlsx')}>
                  <FileSpreadsheet className="w-4 h-4 mr-2" />
                  Excel
                </Button>
              </div>
            </div>
          )}

          {/* MBAT Food Trucks View */}
          {mbatData && mbatViewMode === "foodtrucks" && !mbatSelectedFoodTruck && (
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Building2 className="w-5 h-5 text-primary" />
                  Récapitulatif par Food Truck
                </CardTitle>
              </CardHeader>
              <CardContent>
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Food Truck</TableHead>
                      <TableHead className="text-right">Transactions</TableHead>
                      <TableHead className="text-right">CA TTC</TableHead>
                      <TableHead className="text-right">CA HT</TableHead>
                      <TableHead className="text-right">TVA</TableHead>
                      <TableHead className="text-right">Commission HEC (10% HT)</TableHead>
                      <TableHead></TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {mbatData.food_trucks?.map((ft, idx) => (
                      <TableRow key={idx} className="hover:bg-gray-50 cursor-pointer" onClick={() => setMbatSelectedFoodTruck(ft)}>
                        <TableCell className="font-medium">{ft.nom}</TableCell>
                        <TableCell className="text-right">{ft.nb_transactions}</TableCell>
                        <TableCell className="text-right font-semibold text-green-600">
                          {ft.total_ttc?.toLocaleString("fr-FR")} €
                        </TableCell>
                        <TableCell className="text-right">
                          {ft.total_ht?.toLocaleString("fr-FR")} €
                        </TableCell>
                        <TableCell className="text-right text-muted-foreground">
                          {ft.tva?.toLocaleString("fr-FR")} €
                        </TableCell>
                        <TableCell className="text-right font-semibold text-blue-600">
                          {ft.commission_hec?.toLocaleString("fr-FR")} €
                        </TableCell>
                        <TableCell>
                          <Button size="sm" variant="ghost" onClick={(e) => { e.stopPropagation(); setMbatSelectedFoodTruck(ft); }}>
                            <Eye className="w-4 h-4" />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                    {/* Total Global Row */}
                    <TableRow className="bg-indigo-50 font-bold border-t-2 border-indigo-300" data-testid="row-total-global">
                      <TableCell className="font-bold text-indigo-800">TOTAL GLOBAL</TableCell>
                      <TableCell className="text-right font-bold text-indigo-800">
                        {mbatData.total_transactions?.toLocaleString("fr-FR")}
                      </TableCell>
                      <TableCell className="text-right font-bold text-green-700">
                        {mbatData.total_ttc?.toLocaleString("fr-FR")} €
                      </TableCell>
                      <TableCell className="text-right font-bold text-teal-700">
                        {mbatData.total_ht?.toLocaleString("fr-FR")} €
                      </TableCell>
                      <TableCell className="text-right font-bold text-gray-600">
                        {(mbatData.total_ttc - mbatData.total_ht)?.toLocaleString("fr-FR")} €
                      </TableCell>
                      <TableCell className="text-right font-bold text-indigo-700 text-lg" data-testid="cell-commission-globale">
                        {mbatData.commission_hec_globale?.toLocaleString("fr-FR")} €
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          )}

          {/* MBAT Selected Food Truck Detail */}
          {mbatData && mbatViewMode === "foodtrucks" && mbatSelectedFoodTruck && (
            <Card>
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <Building2 className="w-5 h-5 text-primary" />
                    {mbatSelectedFoodTruck.nom} - Détail des ventes
                  </CardTitle>
                  <Button variant="outline" size="sm" onClick={() => setMbatSelectedFoodTruck(null)}>
                    <X className="w-4 h-4 mr-2" />
                    Retour
                  </Button>
                </div>
                <div className="flex gap-4 mt-2 text-sm">
                  <Badge variant="outline" className="bg-green-50 text-green-700">
                    CA TTC: {mbatSelectedFoodTruck.total_ttc?.toLocaleString("fr-FR")} €
                  </Badge>
                  <Badge variant="outline" className="bg-blue-50 text-blue-700">
                    Commission: {mbatSelectedFoodTruck.commission_hec?.toLocaleString("fr-FR")} €
                  </Badge>
                </div>
              </CardHeader>
              <CardContent>
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Article</TableHead>
                      <TableHead className="text-right">Quantité</TableHead>
                      <TableHead className="text-right">Total TTC</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {mbatSelectedFoodTruck.articles?.map((article, idx) => (
                      <TableRow key={idx}>
                        <TableCell className="font-medium">{article.nom}</TableCell>
                        <TableCell className="text-right">{article.quantite}</TableCell>
                        <TableCell className="text-right font-semibold">
                          {article.total_ttc?.toLocaleString("fr-FR")} €
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          )}

          {/* MBAT Articles View */}
          {mbatData && mbatViewMode === "articles" && (
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <BarChart3 className="w-5 h-5 text-primary" />
                  Récapitulatif par Article (Top 50)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Article</TableHead>
                      <TableHead className="text-right">Quantité</TableHead>
                      <TableHead className="text-right">Total TTC</TableHead>
                      <TableHead className="text-right">Food Trucks</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {mbatData.articles?.map((article, idx) => (
                      <TableRow key={idx}>
                        <TableCell className="font-medium">{article.nom}</TableCell>
                        <TableCell className="text-right">{article.quantite}</TableCell>
                        <TableCell className="text-right font-semibold text-green-600">
                          {article.total_ttc?.toLocaleString("fr-FR")} €
                        </TableCell>
                        <TableCell className="text-right">
                          <Badge variant="outline">{article.nb_food_trucks}</Badge>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          )}

          {/* JETONS View */}
          {mbatViewMode === "jetons" && (
            <div className="space-y-4">
              {/* Planning Status */}
              {jetonsData?.planning_loaded ? (
                <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center gap-2 mb-2">
                    <CheckCircle className="w-5 h-5 text-green-600" />
                    <span className="font-semibold text-green-800">
                      Planning HEC chargé
                    </span>
                  </div>
                  <p className="text-sm text-green-700">
                    Dates : {jetonsData.planning_dates?.join(", ") || "N/A"}
                  </p>
                </div>
              ) : (
                <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
                  <div className="flex items-center gap-2">
                    <AlertCircle className="w-5 h-5 text-amber-600" />
                    <span className="font-semibold text-amber-800">
                      Planning HEC non configuré - Gratuits non calculables
                    </span>
                  </div>
                </div>
              )}

              {/* SYNTHÈSE RAPIDE - 3 cartes principales */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Card className="bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200">
                  <CardContent className="pt-6">
                    <div className="text-center">
                      <p className="text-sm text-amber-600 font-medium">Total Jetons</p>
                      <p className="text-4xl font-bold text-amber-800">
                        {jetonsData?.total_jetons || 0}
                      </p>
                      <p className="text-xs text-amber-600 mt-1">
                        Pool HEC : {jetonsData?.pool_global || 200} offerts
                      </p>
                    </div>
                  </CardContent>
                </Card>

                <Card className={`bg-gradient-to-br ${(jetonsData?.depassement_hec || 0) > 0 ? 'from-red-50 to-red-100 border-red-300' : 'from-gray-50 to-gray-100 border-gray-200'}`}>
                  <CardContent className="pt-6">
                    <div className="text-center">
                      <p className={`text-sm font-medium ${(jetonsData?.depassement_hec || 0) > 0 ? 'text-red-600' : 'text-gray-600'}`}>
                        HEC doit payer
                      </p>
                      <p className={`text-4xl font-bold ${(jetonsData?.depassement_hec || 0) > 0 ? 'text-red-800' : 'text-gray-800'}`}>
                        {(jetonsData?.du_par_hec || 0).toLocaleString("fr-FR")} €
                      </p>
                      <p className={`text-xs mt-1 ${(jetonsData?.depassement_hec || 0) > 0 ? 'text-red-600' : 'text-gray-500'}`}>
                        {jetonsData?.depassement_hec || 0} plats au-delà des 200
                      </p>
                    </div>
                  </CardContent>
                </Card>

                <Card className={`bg-gradient-to-br ${(jetonsData?.total_du_par_ftu || 0) > 0 ? 'from-blue-50 to-blue-100 border-blue-300' : 'from-gray-50 to-gray-100 border-gray-200'}`}>
                  <CardContent className="pt-6">
                    <div className="text-center">
                      <p className={`text-sm font-medium ${(jetonsData?.total_du_par_ftu || 0) > 0 ? 'text-blue-600' : 'text-gray-600'}`}>
                        FTU doit aux Food Trucks
                      </p>
                      <p className={`text-4xl font-bold ${(jetonsData?.total_du_par_ftu || 0) > 0 ? 'text-blue-800' : 'text-gray-800'}`}>
                        {(jetonsData?.total_du_par_ftu || 0).toLocaleString("fr-FR")} €
                      </p>
                      <p className={`text-xs mt-1 ${(jetonsData?.total_du_par_ftu || 0) > 0 ? 'text-blue-600' : 'text-gray-500'}`}>
                        {jetonsData?.total_surplus_ft || 0} plats en surplus
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>

              {/* Règles */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-3 bg-purple-50 border border-purple-200 rounded-lg text-sm">
                  <p className="font-semibold text-purple-800 mb-1">Règle HEC</p>
                  <p className="text-purple-700">200 jetons offerts au total. Au-delà = facturé à HEC à {jetonsData?.excess_price || 11}€/plat</p>
                </div>
                <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm">
                  <p className="font-semibold text-blue-800 mb-1">Règle Food Trucks</p>
                  <p className="text-blue-700">Par présence : {jetonsData?.jeton_par_service_midi || 6} gratuits/Midi, {jetonsData?.jeton_par_service_soir || 8} gratuits/Soir <span className="text-orange-600">(sauf samedi soir = 0)</span></p>
                </div>
              </div>

              {/* Tableau détaillé par Food Truck */}
              <Card>
                <CardHeader className="flex flex-row items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <Building2 className="w-5 h-5 text-primary" />
                    Détail par Food Truck (lié au Planning HEC)
                  </CardTitle>
                  <div className="flex gap-2">
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => fetchJetonsData()}
                      data-testid="btn-refresh-jetons"
                    >
                      <RefreshCw className="w-4 h-4 mr-2" />
                      Rafraîchir
                    </Button>
                    <Button 
                      variant="outline" 
                      size="sm"
                      className="border-blue-300 text-blue-600 hover:bg-blue-50"
                      onClick={() => setShowRenameJetonDialog(true)}
                      data-testid="btn-rename-jeton-foodtruck"
                    >
                      <Edit className="w-4 h-4 mr-2" />
                      Renommer
                    </Button>
                    <Button 
                      variant="outline" 
                      size="sm"
                      className="border-red-300 text-red-600 hover:bg-red-50"
                      onClick={() => setShowDeleteJetonFTDialog(true)}
                      data-testid="btn-delete-jeton-foodtruck"
                    >
                      <Trash2 className="w-4 h-4 mr-2" />
                      Supprimer FT
                    </Button>
                    <Button onClick={() => setShowJetonDialog(true)} size="sm">
                      <Plus className="w-4 h-4 mr-2" />
                      Ajouter Jeton
                    </Button>
                  </div>
                </CardHeader>
                <CardContent>
                  {jetonsData?.food_truck_results?.length > 0 ? (
                    <div className="overflow-x-auto">
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead>Food Truck</TableHead>
                            <TableHead className="text-center">Présences</TableHead>
                            <TableHead className="text-center">Gratuits</TableHead>
                            <TableHead className="text-center">Jetons Midi</TableHead>
                            <TableHead className="text-center">Jetons Soir</TableHead>
                            <TableHead className="text-center">Total Jetons</TableHead>
                            <TableHead className="text-center">Surplus/Déficit</TableHead>
                            <TableHead className="text-right">FTU doit au FT</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {jetonsData.food_truck_results.filter(ft => ft.is_present || ft.has_jetons).map((ft, idx) => (
                            <TableRow key={idx} className={
                              ft.surplus_total > 0 ? 'bg-blue-50' : 
                              ft.surplus_total < 0 ? 'bg-orange-50' : 
                              ft.absent_with_jetons ? 'bg-red-50' : ''
                            }>
                              <TableCell className="font-medium">
                                {ft.food_truck}
                                {ft.absent_with_jetons && (
                                  <Badge className="ml-2 bg-red-100 text-red-800 text-xs">Non planifié</Badge>
                                )}
                              </TableCell>
                              <TableCell className="text-center text-sm">
                                {ft.is_present ? (
                                  <span>
                                    {ft.nb_services_midi > 0 && <span className="text-amber-600">{ft.nb_services_midi}M</span>}
                                    {ft.nb_services_midi > 0 && ft.nb_services_soir > 0 && " + "}
                                    {ft.nb_services_soir > 0 && (
                                      <span className="text-purple-600">
                                        {ft.nb_services_soir}S
                                        {ft.nb_services_soir_samedi > 0 && <span className="text-orange-500 text-xs"> ({ft.nb_services_soir_samedi} sam)</span>}
                                      </span>
                                    )}
                                  </span>
                                ) : (
                                  <span className="text-gray-400">-</span>
                                )}
                              </TableCell>
                              <TableCell className="text-center">
                                <span className="text-green-600 font-medium">{ft.gratuits_total}</span>
                                <span className="text-xs text-gray-500 ml-1">({ft.gratuits_midi}M+{ft.gratuits_soir}S)</span>
                              </TableCell>
                              <TableCell className={`text-center ${ft.jetons_midi > ft.gratuits_midi ? 'text-red-600 font-bold' : ''}`}>
                                {ft.jetons_midi}
                              </TableCell>
                              <TableCell className={`text-center ${ft.jetons_soir > ft.gratuits_soir ? 'text-red-600 font-bold' : ''}`}>
                                {ft.jetons_soir}
                              </TableCell>
                              <TableCell className="text-center font-semibold">{ft.jetons_total}</TableCell>
                              <TableCell className={`text-center font-bold ${
                                ft.surplus_total > 0 ? 'text-blue-600' : 
                                ft.surplus_total < 0 ? 'text-orange-600' : 'text-gray-400'
                              }`}>
                                {ft.surplus_total > 0 ? `+${ft.surplus_total}` : ft.surplus_total}
                              </TableCell>
                              <TableCell className={`text-right font-bold ${
                                ft.du_par_ftu > 0 ? 'text-blue-600' : 
                                ft.du_par_ftu < 0 ? 'text-orange-600' : 'text-gray-400'
                              }`}>
                                {ft.du_par_ftu !== 0 ? `${ft.du_par_ftu.toLocaleString("fr-FR")} €` : '-'}
                              </TableCell>
                            </TableRow>
                          ))}
                          {/* Total Row */}
                          <TableRow className="bg-gray-100 font-bold border-t-2">
                            <TableCell className="font-bold">TOTAL</TableCell>
                            <TableCell className="text-center">-</TableCell>
                            <TableCell className="text-center text-green-600">{jetonsData?.total_gratuits || 0}</TableCell>
                            <TableCell className="text-center">
                              {jetonsData.food_truck_results.reduce((sum, ft) => sum + ft.jetons_midi, 0)}
                            </TableCell>
                            <TableCell className="text-center">
                              {jetonsData.food_truck_results.reduce((sum, ft) => sum + ft.jetons_soir, 0)}
                            </TableCell>
                            <TableCell className="text-center font-bold">{jetonsData?.total_jetons || 0}</TableCell>
                            <TableCell className="text-center text-blue-600">
                              +{jetonsData?.total_surplus_ft || 0}
                            </TableCell>
                            <TableCell className="text-right text-blue-600 font-bold">
                              {(jetonsData?.total_du_par_ftu || 0).toLocaleString("fr-FR")} €
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </div>
                  ) : (
                    <div className="text-center py-8 text-muted-foreground">
                      <Ticket className="w-12 h-12 mx-auto mb-4 opacity-50" />
                      <p>Aucun jeton enregistré</p>
                      <Button className="mt-4" onClick={() => setShowJetonDialog(true)}>
                        <Plus className="w-4 h-4 mr-2" />
                        Ajouter le premier jeton
                      </Button>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Légende */}
              <div className="flex flex-wrap gap-4 text-sm">
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-blue-100 border border-blue-300 rounded"></div>
                  <span>Surplus (FTU doit au FT)</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-orange-100 border border-orange-300 rounded"></div>
                  <span>Déficit (FT n'a pas utilisé tous ses gratuits)</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-red-100 border border-red-300 rounded"></div>
                  <span>Non planifié mais avec jetons</span>
                </div>
              </div>

              {/* All Jetons List */}
              {jetonsData?.jetons?.length > 0 && (
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <FileText className="w-5 h-5 text-primary" />
                      Détail des Jetons
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Date</TableHead>
                          <TableHead>Service</TableHead>
                          <TableHead>Food Truck</TableHead>
                          <TableHead className="text-right">Quantité</TableHead>
                          <TableHead>Notes</TableHead>
                          <TableHead></TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {jetonsData.jetons.map((jeton, idx) => (
                          <TableRow key={idx}>
                            <TableCell>
                              {new Date(jeton.date).toLocaleDateString("fr-FR")}
                            </TableCell>
                            <TableCell>
                              <Badge variant="outline" className={jeton.service === "soir" ? "bg-indigo-50 text-indigo-700" : "bg-amber-50 text-amber-700"}>
                                {jeton.service === "soir" ? "🌙 Soir" : "🌞 Midi"}
                              </Badge>
                            </TableCell>
                            <TableCell className="font-medium">{jeton.food_truck}</TableCell>
                            <TableCell className="text-right font-semibold">{jeton.quantite}</TableCell>
                            <TableCell className="text-muted-foreground text-sm">{jeton.notes}</TableCell>
                            <TableCell>
                              <Button variant="ghost" size="sm" onClick={() => handleDeleteJeton(jeton.id)}>
                                <Trash2 className="w-4 h-4 text-red-500" />
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              )}
            </div>
          )}

          {/* CROIX BLANCHE View */}
          {mbatViewMode === "croixblanche" && (
            <div className="space-y-4">
              {/* Croix Blanche Summary */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <Card className="bg-gradient-to-br from-red-50 to-red-100 border-red-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-red-600 font-medium">Total Facturé</p>
                        <p className="text-2xl font-bold text-red-800">
                          {(croixBlancheData?.grand_total || 0).toLocaleString("fr-FR")} €
                        </p>
                      </div>
                      <Cross className="w-10 h-10 text-red-400" />
                    </div>
                  </CardContent>
                </Card>

                <Card className="bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-amber-600 font-medium">Boissons</p>
                        <p className="text-2xl font-bold text-amber-800">
                          {(croixBlancheData?.type_totals?.boisson || 0).toLocaleString("fr-FR")} €
                        </p>
                      </div>
                      <Coffee className="w-10 h-10 text-amber-400" />
                    </div>
                  </CardContent>
                </Card>

                <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-green-600 font-medium">Plats</p>
                        <p className="text-2xl font-bold text-green-800">
                          {(croixBlancheData?.type_totals?.plat || 0).toLocaleString("fr-FR")} €
                        </p>
                      </div>
                      <UtensilsCrossed className="w-10 h-10 text-green-400" />
                    </div>
                  </CardContent>
                </Card>

                <Card className="bg-gradient-to-br from-pink-50 to-pink-100 border-pink-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-pink-600 font-medium">Desserts</p>
                        <p className="text-2xl font-bold text-pink-800">
                          {(croixBlancheData?.type_totals?.dessert || 0).toLocaleString("fr-FR")} €
                        </p>
                      </div>
                      <Cake className="w-10 h-10 text-pink-400" />
                    </div>
                  </CardContent>
                </Card>
              </div>

              {/* By Food Truck */}
              <Card>
                <CardHeader className="flex flex-row items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <Building2 className="w-5 h-5 text-primary" />
                    Facturation par Food Truck
                  </CardTitle>
                  <Button onClick={() => setShowCroixBlancheDialog(true)} size="sm">
                    <Plus className="w-4 h-4 mr-2" />
                    Ajouter
                  </Button>
                </CardHeader>
                <CardContent>
                  {croixBlancheData?.food_truck_totals && Object.keys(croixBlancheData.food_truck_totals).length > 0 ? (
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Food Truck</TableHead>
                          <TableHead className="text-right">Boissons</TableHead>
                          <TableHead className="text-right">Plats</TableHead>
                          <TableHead className="text-right">Desserts</TableHead>
                          <TableHead className="text-right">Total</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {Object.entries(croixBlancheData.food_truck_totals)
                          .sort((a, b) => b[1].total - a[1].total)
                          .map(([ft, data], idx) => (
                          <TableRow key={idx}>
                            <TableCell className="font-medium">{ft}</TableCell>
                            <TableCell className="text-right">{(data.boisson || 0).toLocaleString("fr-FR")} €</TableCell>
                            <TableCell className="text-right">{(data.plat || 0).toLocaleString("fr-FR")} €</TableCell>
                            <TableCell className="text-right">{(data.dessert || 0).toLocaleString("fr-FR")} €</TableCell>
                            <TableCell className="text-right font-semibold text-red-600">
                              {(data.total || 0).toLocaleString("fr-FR")} €
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  ) : (
                    <div className="text-center py-8 text-muted-foreground">
                      <Cross className="w-12 h-12 mx-auto mb-4 opacity-50" />
                      <p>Aucune consommation Croix Blanche enregistrée</p>
                      <Button className="mt-4" onClick={() => setShowCroixBlancheDialog(true)}>
                        <Plus className="w-4 h-4 mr-2" />
                        Ajouter une consommation
                      </Button>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* All Entries */}
              {croixBlancheData?.entries?.length > 0 && (
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <FileText className="w-5 h-5 text-primary" />
                      Détail des Consommations
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Date</TableHead>
                          <TableHead>Food Truck</TableHead>
                          <TableHead>Type</TableHead>
                          <TableHead>Description</TableHead>
                          <TableHead className="text-right">Qté</TableHead>
                          <TableHead className="text-right">Prix U.</TableHead>
                          <TableHead className="text-right">Total</TableHead>
                          <TableHead></TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {croixBlancheData.entries.map((entry, idx) => (
                          <TableRow key={idx}>
                            <TableCell>{new Date(entry.date).toLocaleDateString("fr-FR")}</TableCell>
                            <TableCell className="font-medium">{entry.food_truck}</TableCell>
                            <TableCell>
                              <Badge variant="outline" className={
                                entry.type === 'boisson' ? 'bg-amber-50 text-amber-700' :
                                entry.type === 'plat' ? 'bg-green-50 text-green-700' :
                                'bg-pink-50 text-pink-700'
                              }>
                                {entry.type === 'boisson' ? '🥤' : entry.type === 'plat' ? '🍽️' : '🍰'} {entry.type}
                              </Badge>
                            </TableCell>
                            <TableCell>{entry.description}</TableCell>
                            <TableCell className="text-right">{entry.quantite}</TableCell>
                            <TableCell className="text-right">{entry.prix_unitaire?.toFixed(2)} €</TableCell>
                            <TableCell className="text-right font-semibold">{entry.total?.toFixed(2)} €</TableCell>
                            <TableCell>
                              <Button variant="ghost" size="sm" onClick={() => handleDeleteCroixBlanche(entry.id)}>
                                <Trash2 className="w-4 h-4 text-red-500" />
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              )}
            </div>
          )}

          {/* UNASSIGNED TRANSACTIONS View */}
          {mbatViewMode === "unassigned" && (
            <div className="space-y-4">
              {/* Summary Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Card className="bg-gradient-to-br from-orange-50 to-orange-100 border-orange-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-orange-600 font-medium">Sans Catégorie</p>
                        <p className="text-2xl font-bold text-orange-800">
                          {unassignedData?.total_unassigned || 0}
                        </p>
                      </div>
                      <CircleHelp className="w-10 h-10 text-orange-400" />
                    </div>
                  </CardContent>
                </Card>

                <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-green-600 font-medium">Déjà Assignées</p>
                        <p className="text-2xl font-bold text-green-800">
                          {unassignedData?.total_assigned || 0}
                        </p>
                      </div>
                      <CheckCircle className="w-10 h-10 text-green-400" />
                    </div>
                  </CardContent>
                </Card>

                <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-blue-600 font-medium">Montant Non Assigné</p>
                        <p className="text-2xl font-bold text-blue-800">
                          {(unassignedData?.total_ttc_unassigned || 0).toLocaleString("fr-FR")} €
                        </p>
                      </div>
                      <Euro className="w-10 h-10 text-blue-400" />
                    </div>
                  </CardContent>
                </Card>
              </div>

              {/* Assignment by Compte (Bulk) */}
              {unassignedData?.by_compte && Object.keys(unassignedData.by_compte).length > 0 && (
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <Users className="w-5 h-5 text-primary" />
                      Assignation en masse par Compte
                    </CardTitle>
                    <p className="text-sm text-muted-foreground">
                      Assignez toutes les transactions d'un compte à un food truck
                    </p>
                  </CardHeader>
                  <CardContent>
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Compte</TableHead>
                          <TableHead className="text-right">Transactions</TableHead>
                          <TableHead className="text-right">Total TTC</TableHead>
                          <TableHead>Assigner à</TableHead>
                          <TableHead></TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {Object.entries(unassignedData.by_compte)
                          .sort((a, b) => b[1].total_ttc - a[1].total_ttc)
                          .map(([compte, data], idx) => (
                          <TableRow key={idx}>
                            <TableCell className="font-medium">{compte || "(vide)"}</TableCell>
                            <TableCell className="text-right">{data.count}</TableCell>
                            <TableCell className="text-right font-semibold">
                              {data.total_ttc?.toLocaleString("fr-FR")} €
                            </TableCell>
                            <TableCell>
                              <Select
                                onValueChange={(ft) => handleAssignByCompte(compte, ft)}
                                disabled={isAssigning}
                              >
                                <SelectTrigger className="w-48">
                                  <SelectValue placeholder="Choisir FT..." />
                                </SelectTrigger>
                                <SelectContent>
                                  {(unassignedData.available_food_trucks || []).map((ft) => (
                                    <SelectItem key={ft} value={ft}>{ft}</SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                            </TableCell>
                            <TableCell>
                              {isAssigning && <Loader2 className="w-4 h-4 animate-spin" />}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              )}

              {/* Individual Transactions */}
              {unassignedData?.transactions?.length > 0 && (
                <Card>
                  <CardHeader className="flex flex-row items-center justify-between">
                    <div>
                      <CardTitle className="flex items-center gap-2">
                        <FileText className="w-5 h-5 text-primary" />
                        Détail des Transactions ({unassignedData.transactions.length})
                      </CardTitle>
                      <p className="text-sm text-muted-foreground mt-1">
                        Sélectionnez les transactions à assigner manuellement
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      <Button variant="outline" size="sm" onClick={selectAllTransactions}>
                        <CheckSquare className="w-4 h-4 mr-2" />
                        Tout sélectionner
                      </Button>
                      <Button variant="outline" size="sm" onClick={deselectAllTransactions}>
                        Désélectionner
                      </Button>
                    </div>
                  </CardHeader>
                  <CardContent>
                    {/* Bulk assign bar */}
                    {selectedTransactions.length > 0 && (
                      <div className="flex items-center gap-3 p-3 mb-4 bg-blue-50 border border-blue-200 rounded-lg">
                        <Badge className="bg-blue-500">{selectedTransactions.length} sélectionnée(s)</Badge>
                        <Select value={assigningTo} onValueChange={setAssigningTo}>
                          <SelectTrigger className="w-56">
                            <SelectValue placeholder="Assigner à..." />
                          </SelectTrigger>
                          <SelectContent>
                            {(unassignedData.available_food_trucks || []).map((ft) => (
                              <SelectItem key={ft} value={ft}>{ft}</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                        <Button onClick={handleAssignTransactions} disabled={isAssigning || !assigningTo}>
                          {isAssigning ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle className="w-4 h-4 mr-2" />}
                          Assigner
                        </Button>
                      </div>
                    )}

                    <div className="max-h-96 overflow-auto">
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead className="w-10"></TableHead>
                            <TableHead>Date</TableHead>
                            <TableHead>Description</TableHead>
                            <TableHead>Compte</TableHead>
                            <TableHead className="text-right">Qté</TableHead>
                            <TableHead className="text-right">TTC</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {unassignedData.transactions.map((tx, idx) => (
                            <TableRow 
                              key={tx.id || idx} 
                              className={`cursor-pointer hover:bg-gray-50 ${selectedTransactions.includes(tx.id) ? 'bg-blue-50' : ''}`}
                              onClick={() => toggleTransactionSelection(tx.id)}
                            >
                              <TableCell>
                                <input
                                  type="checkbox"
                                  checked={selectedTransactions.includes(tx.id)}
                                  onChange={() => toggleTransactionSelection(tx.id)}
                                  className="rounded border-gray-300"
                                />
                              </TableCell>
                              <TableCell className="text-sm">{tx.date}</TableCell>
                              <TableCell className="font-medium max-w-xs truncate">{tx.description}</TableCell>
                              <TableCell className="text-sm text-muted-foreground">{tx.compte}</TableCell>
                              <TableCell className="text-right">{tx.quantite}</TableCell>
                              <TableCell className="text-right font-semibold">{tx.prix_ttc?.toFixed(2)} €</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* No unassigned transactions */}
              {(!unassignedData?.transactions || unassignedData.transactions.length === 0) && (
                <Card className="border-dashed">
                  <CardContent className="py-12 text-center">
                    <CheckCircle className="w-12 h-12 mx-auto text-green-500 mb-4" />
                    <h3 className="font-semibold text-lg mb-2">Toutes les transactions sont assignées !</h3>
                    <p className="text-muted-foreground">
                      Il n'y a plus de transactions sans catégorie à traiter.
                    </p>
                  </CardContent>
                </Card>
              )}

              {/* Assigned Transactions History */}
              {unassignedData?.assigned_transactions?.length > 0 && (
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <CheckCircle className="w-5 h-5 text-green-500" />
                      Transactions Assignées ({unassignedData.assigned_transactions.length})
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="max-h-64 overflow-auto">
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead>Date</TableHead>
                            <TableHead>Description</TableHead>
                            <TableHead>Assignée à</TableHead>
                            <TableHead className="text-right">TTC</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {unassignedData.assigned_transactions.slice(0, 20).map((tx, idx) => (
                            <TableRow key={tx.id || idx}>
                              <TableCell className="text-sm">{tx.date}</TableCell>
                              <TableCell className="font-medium max-w-xs truncate">{tx.description}</TableCell>
                              <TableCell>
                                <Badge className="bg-green-100 text-green-700">{tx.assigned_food_truck}</Badge>
                              </TableCell>
                              <TableCell className="text-right font-semibold">{tx.prix_ttc?.toFixed(2)} €</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                    {unassignedData.assigned_transactions.length > 20 && (
                      <p className="text-sm text-muted-foreground text-center mt-2">
                        ... et {unassignedData.assigned_transactions.length - 20} autres
                      </p>
                    )}
                  </CardContent>
                </Card>
              )}
            </div>
          )}

          {/* Montants Personnalisés Section */}
          {mbatViewMode === "montants_perso" && (
            <div className="space-y-4">
              {/* Summary Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Card className="bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-purple-600 font-medium">Nb Transactions</p>
                        <p className="text-2xl font-bold text-purple-800">
                          {mbatData?.montants_personnalises?.length || 0}
                        </p>
                      </div>
                      <CreditCard className="w-10 h-10 text-purple-400" />
                    </div>
                  </CardContent>
                </Card>

                <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-green-600 font-medium">Total TTC</p>
                        <p className="text-2xl font-bold text-green-800">
                          {(mbatData?.montants_personnalises?.reduce((sum, m) => sum + (m.prix_ttc || 0), 0) || 0).toLocaleString("fr-FR")} €
                        </p>
                      </div>
                      <Euro className="w-10 h-10 text-green-400" />
                    </div>
                  </CardContent>
                </Card>

                <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
                  <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-blue-600 font-medium">Food Trucks concernés</p>
                        <p className="text-2xl font-bold text-blue-800">
                          {[...new Set(mbatData?.montants_personnalises?.map(m => m.food_truck) || [])].length}
                        </p>
                      </div>
                      <Building2 className="w-10 h-10 text-blue-400" />
                    </div>
                  </CardContent>
                </Card>
              </div>

              {/* Info Box */}
              <div className="p-4 bg-purple-50 border border-purple-200 rounded-lg text-sm text-purple-700">
                <AlertCircle className="w-4 h-4 inline mr-2" />
                <strong>Montants personnalisés :</strong> Ce sont les ventes saisies manuellement sur le terminal de paiement, 
                sans article prédéfini dans le catalogue. Cela peut correspondre à des ajustements, des combinaisons de plats, 
                ou des articles non répertoriés.
              </div>

              {/* Transactions Table */}
              {mbatData?.montants_personnalises?.length > 0 ? (
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <CreditCard className="w-5 h-5 text-purple-500" />
                      Détail des Montants Personnalisés ({mbatData.montants_personnalises.length} transactions)
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="overflow-auto max-h-[600px]">
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead>Date</TableHead>
                            <TableHead>Heure</TableHead>
                            <TableHead>Food Truck</TableHead>
                            <TableHead className="text-right">Prix TTC</TableHead>
                            <TableHead className="text-right">Prix HT</TableHead>
                            <TableHead>Moyen Paiement</TableHead>
                            <TableHead>Réf. Transaction</TableHead>
                            {isSuperAdmin && <TableHead className="text-center">Reclasser</TableHead>}
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {mbatData.montants_personnalises.map((mp, idx) => {
                            // Parse date and time - format can be "12 mai" or "12/05/2024 14:30"
                            const dateStr = mp.date || "";
                            let displayDate = dateStr;
                            let displayTime = mp.heure || "";
                            
                            // Try to extract time if present (HH:MM format)
                            const timeMatch = dateStr.match(/(\d{1,2}:\d{2})/);
                            if (timeMatch) {
                              displayTime = timeMatch[1];
                              displayDate = dateStr.replace(timeMatch[0], "").trim();
                            }
                            
                            return (
                              <TableRow key={mp.id || idx}>
                                <TableCell className="font-medium">
                                  {displayDate}
                                </TableCell>
                                <TableCell className="text-blue-600 font-semibold">
                                  {displayTime || "-"}
                                </TableCell>
                                <TableCell>
                                  <Badge variant="outline" className="bg-purple-50 text-purple-700">
                                    {mp.food_truck}
                                  </Badge>
                                </TableCell>
                                <TableCell className="text-right font-semibold text-green-600">
                                  {mp.prix_ttc?.toLocaleString("fr-FR")} €
                                </TableCell>
                                <TableCell className="text-right text-muted-foreground">
                                  {mp.prix_ht?.toLocaleString("fr-FR")} €
                                </TableCell>
                                <TableCell className="text-sm">
                                  {mp.moyen_paiement || "-"}
                                </TableCell>
                                <TableCell className="text-xs text-muted-foreground font-mono">
                                  {mp.ref_transaction?.slice(0, 12)}...
                                </TableCell>
                                {isSuperAdmin && (
                                  <TableCell className="text-center">
                                    <Button
                                      variant="outline"
                                      size="sm"
                                      className="text-purple-600 hover:bg-purple-50"
                                      onClick={() => {
                                        setReclassementItem(mp);
                                        setReclassementTarget({ food_truck: mp.food_truck || "", article: "" });
                                        setShowReclassementDialog(true);
                                      }}
                                    >
                                      <ArrowRightLeft className="w-4 h-4" />
                                    </Button>
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  </CardContent>
                </Card>
              ) : (
                <Card className="border-dashed">
                  <CardContent className="py-12 text-center">
                    <CheckCircle className="w-12 h-12 mx-auto text-green-500 mb-4" />
                    <h3 className="font-semibold text-lg mb-2">Aucun montant personnalisé</h3>
                    <p className="text-muted-foreground">
                      Toutes les ventes ont été effectuées via le catalogue d'articles.
                    </p>
                  </CardContent>
                </Card>
              )}

              {/* Summary by Food Truck */}
              {mbatData?.montants_personnalises?.length > 0 && (
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <Building2 className="w-5 h-5 text-primary" />
                      Récapitulatif par Food Truck
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Food Truck</TableHead>
                          <TableHead className="text-right">Nb Transactions</TableHead>
                          <TableHead className="text-right">Total TTC</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {Object.entries(
                          (mbatData?.montants_personnalises || []).reduce((acc, mp) => {
                            const ft = mp.food_truck || "Inconnu";
                            if (!acc[ft]) acc[ft] = { count: 0, total: 0 };
                            acc[ft].count++;
                            acc[ft].total += mp.prix_ttc || 0;
                            return acc;
                          }, {})
                        )
                          .sort((a, b) => b[1].total - a[1].total)
                          .map(([ft, data], idx) => (
                            <TableRow key={idx}>
                              <TableCell className="font-medium">{ft}</TableCell>
                              <TableCell className="text-right">{data.count}</TableCell>
                              <TableCell className="text-right font-semibold text-green-600">
                                {data.total.toLocaleString("fr-FR")} €
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              )}
            </div>
          )}

          {/* No Data State */}
          {!mbatData && (
            <Card className="border-dashed">
              <CardContent className="py-12 text-center">
                <Upload className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
                <h3 className="font-semibold text-lg mb-2">Aucun fichier MBAT importé</h3>
                <p className="text-muted-foreground mb-4">
                  Importez un fichier CSV exporté depuis le terminal de paiement pour analyser les transactions.
                </p>
                <div className="relative inline-block">
                  <input
                    type="file"
                    accept=".csv"
                    onChange={handleMbatUpload}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    disabled={uploadingMbat}
                  />
                  <Button disabled={uploadingMbat}>
                    {uploadingMbat ? (
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    ) : (
                      <Upload className="w-4 h-4 mr-2" />
                    )}
                    Sélectionner un fichier
                  </Button>
                </div>
              </CardContent>
            </Card>
          )}

          {/* MBAT Info */}
          {mbatData && (
            <div className="text-xs text-muted-foreground text-right">
              Importé le {new Date(mbatData.uploaded_at).toLocaleDateString("fr-FR", { 
                day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" 
              })}
              {" • "}{mbatData.filename}
            </div>
          )}
        </TabsContent>
      </Tabs>

      {/* Invoice Dialog */}
      <Dialog open={showInvoiceDialog} onOpenChange={setShowInvoiceDialog}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="w-5 h-5 text-primary" />
              {editingInvoice?.id ? "Modifier la facture" : "Nouvelle facture"}
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            {ocrResult && (
              <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-700">
                <Eye className="w-4 h-4 inline mr-1" />
                Données extraites par OCR - Vérifiez et corrigez si nécessaire
              </div>
            )}

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Fournisseur *</Label>
                <Input
                  value={editingInvoice?.fournisseur || ""}
                  onChange={(e) => setEditingInvoice({ ...editingInvoice, fournisseur: e.target.value })}
                  placeholder="Nom du fournisseur"
                />
              </div>
              <div>
                <Label>N° Facture</Label>
                <Input
                  value={editingInvoice?.numero_facture || ""}
                  onChange={(e) => setEditingInvoice({ ...editingInvoice, numero_facture: e.target.value })}
                  placeholder="Numéro de facture"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Date facture *</Label>
                <Input
                  type="date"
                  value={editingInvoice?.date_facture || ""}
                  onChange={(e) => setEditingInvoice({ ...editingInvoice, date_facture: e.target.value })}
                />
              </div>
              <div>
                <Label>Montant total (€) *</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={editingInvoice?.montant_total || ""}
                  onChange={(e) => setEditingInvoice({ ...editingInvoice, montant_total: parseFloat(e.target.value) || 0 })}
                  placeholder="0.00"
                />
              </div>
            </div>

            {/* Items */}
            <div>
              <div className="flex justify-between items-center mb-2">
                <Label>Articles</Label>
                <Button size="sm" variant="outline" onClick={addInvoiceItem}>
                  <Plus className="w-4 h-4 mr-1" /> Ajouter
                </Button>
              </div>

              {editingInvoice?.items?.length > 0 ? (
                <div className="space-y-3 max-h-80 overflow-y-auto border rounded-lg p-3 bg-gray-50">
                  {/* Header row */}
                  <div className="grid grid-cols-12 gap-2 text-xs font-semibold text-gray-600 px-2 pb-2 border-b">
                    <div className="col-span-1 text-center">Qté</div>
                    <div className="col-span-2">Conditionnement</div>
                    <div className="col-span-4">Désignation</div>
                    <div className="col-span-2 text-right">Prix Unit. €</div>
                    <div className="col-span-2 text-right">Montant €</div>
                    <div className="col-span-1">Catég.</div>
                  </div>
                  
                  {editingInvoice.items.map((item, index) => (
                    <div key={index} className="grid grid-cols-12 gap-2 items-center p-2 bg-white rounded border">
                      {/* Quantité */}
                      <div className="col-span-1">
                        <Input
                          type="number"
                          placeholder="Qté"
                          value={item.quantity || ""}
                          onChange={(e) => updateInvoiceItem(index, "quantity", parseFloat(e.target.value) || 0)}
                          className="text-sm text-center font-medium"
                        />
                      </div>
                      
                      {/* Conditionnement/Unité */}
                      <div className="col-span-2">
                        <Select
                          value={item.unite || "unité"}
                          onValueChange={(v) => updateInvoiceItem(index, "unite", v)}
                        >
                          <SelectTrigger className="text-sm">
                            <SelectValue placeholder="Unité" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="unité">Unité</SelectItem>
                            <SelectItem value="pack">Pack</SelectItem>
                            <SelectItem value="fût 30L">Fût 30L</SelectItem>
                            <SelectItem value="fût 20L">Fût 20L</SelectItem>
                            <SelectItem value="fût">Fût</SelectItem>
                            <SelectItem value="litre">Litre</SelectItem>
                            <SelectItem value="kg">Kg</SelectItem>
                            <SelectItem value="carton">Carton</SelectItem>
                            <SelectItem value="bouteille">Bouteille</SelectItem>
                            <SelectItem value="BIB 10L">BIB 10L</SelectItem>
                            <SelectItem value="BIB 5L">BIB 5L</SelectItem>
                            <SelectItem value="forfait">Forfait</SelectItem>
                            <SelectItem value="pack 24x33cl">Pack 24x33cl</SelectItem>
                            <SelectItem value="pack 6x33cl">Pack 6x33cl</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                      
                      {/* Désignation */}
                      <div className="col-span-4">
                        <Input
                          placeholder="Désignation du produit"
                          value={item.description || ""}
                          onChange={(e) => updateInvoiceItem(index, "description", e.target.value)}
                          className="text-sm"
                        />
                      </div>
                      
                      {/* Prix unitaire */}
                      <div className="col-span-2">
                        <Input
                          type="number"
                          step="0.01"
                          placeholder="P.U."
                          value={item.unit_price || ""}
                          onChange={(e) => updateInvoiceItem(index, "unit_price", parseFloat(e.target.value) || 0)}
                          className="text-sm text-right"
                        />
                      </div>
                      
                      {/* Montant Total */}
                      <div className="col-span-2">
                        <Input
                          type="number"
                          step="0.01"
                          placeholder="Montant"
                          value={item.total || ""}
                          onChange={(e) => updateInvoiceItem(index, "total", parseFloat(e.target.value) || 0)}
                          className="text-sm text-right font-semibold"
                        />
                      </div>
                      
                      {/* Catégorie + Delete */}
                      <div className="col-span-1 flex items-center gap-1">
                        <Select
                          value={item.category || "Divers"}
                          onValueChange={(v) => updateInvoiceItem(index, "category", v)}
                        >
                          <SelectTrigger className="text-xs px-1 h-8">
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            {CATEGORIES.map((cat) => (
                              <SelectItem key={cat} value={cat}>{cat}</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                        <Button
                          size="sm"
                          variant="ghost"
                          className="text-red-500 h-8 w-8 p-0 shrink-0"
                          onClick={() => removeInvoiceItem(index)}
                        >
                          <X className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                  ))}
                  
                  {/* Total row */}
                  <div className="flex justify-end pt-2 border-t mt-2">
                    <div className="text-sm font-semibold">
                      Total articles: <span className="text-primary ml-2">{editingInvoice.items.reduce((sum, item) => sum + (item.total || 0), 0).toLocaleString("fr-FR")} €</span>
                    </div>
                  </div>
                </div>
              ) : (
                <p className="text-sm text-gray-500 text-center py-4 border rounded-lg bg-gray-50">Aucun article - Cliquez sur "Ajouter" pour ajouter des lignes</p>
              )}
            </div>

            <div>
              <Label>Notes</Label>
              <Input
                value={editingInvoice?.notes || ""}
                onChange={(e) => setEditingInvoice({ ...editingInvoice, notes: e.target.value })}
                placeholder="Notes optionnelles"
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowInvoiceDialog(false)}>
              Annuler
            </Button>
            <Button onClick={handleSaveInvoice} disabled={savingInvoice}>
              {savingInvoice ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
              Enregistrer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Acompte Dialog */}
      <Dialog open={showAcompteDialog} onOpenChange={setShowAcompteDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CreditCard className="w-5 h-5 text-green-600" />
              Ajouter un acompte
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            <div>
              <Label>Montant (€) *</Label>
              <Input
                type="number"
                step="0.01"
                value={newAcompte.montant}
                onChange={(e) => setNewAcompte({ ...newAcompte, montant: e.target.value })}
                placeholder="0.00"
              />
            </div>
            <div>
              <Label>Date de paiement *</Label>
              <Input
                type="date"
                value={newAcompte.date_paiement}
                onChange={(e) => setNewAcompte({ ...newAcompte, date_paiement: e.target.value })}
              />
            </div>
            <div>
              <Label>Notes</Label>
              <Input
                value={newAcompte.notes}
                onChange={(e) => setNewAcompte({ ...newAcompte, notes: e.target.value })}
                placeholder="Notes optionnelles"
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowAcompteDialog(false)}>
              Annuler
            </Button>
            <Button onClick={handleSaveAcompte} disabled={savingAcompte}>
              {savingAcompte ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
              Enregistrer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Jeton Dialog */}
      <Dialog open={showJetonDialog} onOpenChange={setShowJetonDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Ticket className="w-5 h-5 text-amber-500" />
              Ajouter des Jetons (Plats offerts)
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            <div>
              <Label>Food Truck *</Label>
              <Select
                value={newJeton.food_truck}
                onValueChange={(v) => setNewJeton({ ...newJeton, food_truck: v })}
              >
                <SelectTrigger className="mt-1">
                  <SelectValue placeholder="Sélectionner un food truck" />
                </SelectTrigger>
                <SelectContent>
                  {getFoodTrucksList().map((ft) => (
                    <SelectItem key={ft} value={ft}>{ft}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Date *</Label>
                <Input
                  type="date"
                  value={newJeton.date}
                  onChange={(e) => setNewJeton({ ...newJeton, date: e.target.value })}
                  className="mt-1"
                />
              </div>
              
              <div>
                <Label>Service *</Label>
                <Select
                  value={newJeton.service}
                  onValueChange={(v) => setNewJeton({ ...newJeton, service: v })}
                >
                  <SelectTrigger className="mt-1">
                    <SelectValue placeholder="Sélectionner le service" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="midi">🌞 Midi</SelectItem>
                    <SelectItem value="soir">🌙 Soir</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div>
              <Label>Nombre de jetons (plats) *</Label>
              <Input
                type="number"
                min="1"
                value={newJeton.quantite}
                onChange={(e) => setNewJeton({ ...newJeton, quantite: parseInt(e.target.value) || 1 })}
                className="mt-1"
              />
            </div>

            <div>
              <Label>Notes</Label>
              <Input
                value={newJeton.notes}
                onChange={(e) => setNewJeton({ ...newJeton, notes: e.target.value })}
                placeholder="Optionnel..."
                className="mt-1"
              />
            </div>

            <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-700">
              <AlertCircle className="w-4 h-4 inline mr-2" />
              <strong>Règle :</strong> {jetonsData?.nb_food_trucks || 0} FT → Midi: {jetonsData?.limite_midi || 0} jetons ({jetonsData?.jeton_par_ft_midi || 6}/FT) | Soir: {jetonsData?.limite_soir || 0} jetons ({jetonsData?.jeton_par_ft_soir || 8}/FT) | Dépassement: 11€/plat
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowJetonDialog(false)}>
              Annuler
            </Button>
            <Button onClick={handleAddJeton} disabled={savingJeton}>
              {savingJeton ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Plus className="w-4 h-4 mr-2" />}
              Ajouter
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Rename Food Truck in Jetons Dialog */}
      <Dialog open={showRenameJetonDialog} onOpenChange={setShowRenameJetonDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Edit className="w-5 h-5 text-blue-600" />
              Renommer un Food Truck (Jetons)
            </DialogTitle>
          </DialogHeader>
          <div className="py-4 space-y-4">
            <p className="text-sm text-muted-foreground">
              Corrigez le nom d'un food truck pour aligner les données Jetons avec les noms corrects.
            </p>
            
            <div className="space-y-3">
              <div>
                <Label>Nom actuel (à corriger)</Label>
                <Select
                  value={renameJetonData.old_name}
                  onValueChange={(value) => setRenameJetonData({ ...renameJetonData, old_name: value })}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Sélectionner le nom à corriger" />
                  </SelectTrigger>
                  <SelectContent>
                    {/* Liste des food trucks existants dans les jetons */}
                    {jetonsData?.food_truck_results?.filter(ft => ft.has_jetons).map((ft, i) => (
                      <SelectItem key={i} value={ft.food_truck}>
                        {ft.food_truck} ({ft.jetons_total || 0} jetons)
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              
              <div>
                <Label>Nouveau nom (correct)</Label>
                <Input
                  value={renameJetonData.new_name}
                  onChange={(e) => setRenameJetonData({ ...renameJetonData, new_name: e.target.value })}
                  placeholder="Ex: Pizza Toccata"
                />
              </div>
            </div>
            
            {renameJetonData.old_name && renameJetonData.new_name && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm text-blue-800">
                <strong>Aperçu :</strong> "{renameJetonData.old_name}" → "{renameJetonData.new_name}"
              </div>
            )}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => {
              setShowRenameJetonDialog(false);
              setRenameJetonData({ old_name: "", new_name: "" });
            }}>
              Annuler
            </Button>
            <Button 
              onClick={handleRenameJetonFoodTruck}
              disabled={savingJetonRename || !renameJetonData.old_name || !renameJetonData.new_name}
            >
              {savingJetonRename ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <Save className="w-4 h-4 mr-2" />
              )}
              Renommer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Delete Food Truck Jetons Dialog */}
      <Dialog open={showDeleteJetonFTDialog} onOpenChange={setShowDeleteJetonFTDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <Trash2 className="w-5 h-5" />
              Supprimer les Jetons d'un Food Truck
            </DialogTitle>
          </DialogHeader>
          <div className="py-4 space-y-4">
            <p className="text-sm text-muted-foreground">
              Supprimez tous les jetons associés à un food truck mal orthographié ou erroné.
            </p>
            
            <div>
              <Label>Food Truck à supprimer</Label>
              <Select
                value={deleteJetonFT}
                onValueChange={setDeleteJetonFT}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Sélectionner le food truck" />
                </SelectTrigger>
                <SelectContent>
                  {jetonsData?.food_truck_results?.filter(ft => ft.has_jetons).map((ft, i) => (
                    <SelectItem key={i} value={ft.food_truck}>
                      {ft.food_truck} ({ft.jetons_total || 0} jetons)
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            {deleteJetonFT && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-800">
                <AlertCircle className="w-4 h-4 inline mr-2" />
                <strong>Attention :</strong> Tous les jetons de "{deleteJetonFT}" seront définitivement supprimés.
              </div>
            )}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => {
              setShowDeleteJetonFTDialog(false);
              setDeleteJetonFT("");
            }}>
              Annuler
            </Button>
            <Button 
              variant="destructive"
              onClick={handleDeleteJetonFoodTruck}
              disabled={deletingJetonFT || !deleteJetonFT}
            >
              {deletingJetonFT ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <Trash2 className="w-4 h-4 mr-2" />
              )}
              Supprimer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Croix Blanche Dialog */}
      <Dialog open={showCroixBlancheDialog} onOpenChange={setShowCroixBlancheDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Cross className="w-5 h-5 text-red-500" />
              Ajouter Consommation Croix Blanche
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            <div>
              <Label>Food Truck à facturer *</Label>
              <Select
                value={newCroixBlanche.food_truck}
                onValueChange={(v) => setNewCroixBlanche({ ...newCroixBlanche, food_truck: v })}
              >
                <SelectTrigger className="mt-1">
                  <SelectValue placeholder="Sélectionner un food truck" />
                </SelectTrigger>
                <SelectContent>
                  {getFoodTrucksList().map((ft) => (
                    <SelectItem key={ft} value={ft}>{ft}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label>Date *</Label>
              <Input
                type="date"
                value={newCroixBlanche.date}
                onChange={(e) => setNewCroixBlanche({ ...newCroixBlanche, date: e.target.value })}
                className="mt-1"
              />
            </div>

            <div>
              <Label>Type *</Label>
              <Select
                value={newCroixBlanche.type}
                onValueChange={(v) => setNewCroixBlanche({ ...newCroixBlanche, type: v })}
              >
                <SelectTrigger className="mt-1">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="boisson">🥤 Boisson</SelectItem>
                  <SelectItem value="plat">🍽️ Plat</SelectItem>
                  <SelectItem value="dessert">🍰 Dessert</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label>Description *</Label>
              <Input
                value={newCroixBlanche.description}
                onChange={(e) => setNewCroixBlanche({ ...newCroixBlanche, description: e.target.value })}
                placeholder="Ex: Coca-Cola, Sandwich, Brownie..."
                className="mt-1"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Quantité *</Label>
                <Input
                  type="number"
                  min="1"
                  value={newCroixBlanche.quantite}
                  onChange={(e) => setNewCroixBlanche({ ...newCroixBlanche, quantite: parseInt(e.target.value) || 1 })}
                  className="mt-1"
                />
              </div>
              <div>
                <Label>Prix unitaire (€) *</Label>
                <Input
                  type="number"
                  step="0.5"
                  min="0"
                  value={newCroixBlanche.prix_unitaire}
                  onChange={(e) => setNewCroixBlanche({ ...newCroixBlanche, prix_unitaire: parseFloat(e.target.value) || 0 })}
                  className="mt-1"
                />
              </div>
            </div>

            <div className="p-3 bg-gray-50 border rounded-lg">
              <p className="text-sm text-muted-foreground">Total à facturer :</p>
              <p className="text-xl font-bold">
                {(newCroixBlanche.quantite * newCroixBlanche.prix_unitaire).toFixed(2)} €
              </p>
            </div>

            <div>
              <Label>Notes</Label>
              <Input
                value={newCroixBlanche.notes}
                onChange={(e) => setNewCroixBlanche({ ...newCroixBlanche, notes: e.target.value })}
                placeholder="Optionnel..."
                className="mt-1"
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowCroixBlancheDialog(false)}>
              Annuler
            </Button>
            <Button onClick={handleAddCroixBlanche} disabled={savingCroixBlanche}>
              {savingCroixBlanche ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Plus className="w-4 h-4 mr-2" />}
              Ajouter
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Staff Dialog */}
      <Dialog open={showStaffDialog} onOpenChange={setShowStaffDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Users className="w-5 h-5 text-purple-500" />
              Ajouter Staff
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            <div>
              <Label>Nom du staff *</Label>
              <Input
                value={newStaff.nom}
                onChange={(e) => setNewStaff({ ...newStaff, nom: e.target.value })}
                placeholder="Prénom Nom"
                className="mt-1"
              />
            </div>

            <div>
              <Label>Rôle *</Label>
              <Select
                value={newStaff.role}
                onValueChange={(v) => {
                  const defaultRates = { barman: 12.50, securite: 15.00, logistique: 12.00, accueil: 11.65, responsable: 18.00, autre: 12.00 };
                  setNewStaff({ ...newStaff, role: v, taux_horaire: defaultRates[v] || 12.00 });
                }}
              >
                <SelectTrigger className="mt-1">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="barman">Barman</SelectItem>
                  <SelectItem value="securite">Sécurité</SelectItem>
                  <SelectItem value="logistique">Logistique</SelectItem>
                  <SelectItem value="accueil">Accueil</SelectItem>
                  <SelectItem value="responsable">Responsable</SelectItem>
                  <SelectItem value="autre">Autre</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label>Date *</Label>
              <Input
                type="date"
                value={newStaff.date}
                onChange={(e) => setNewStaff({ ...newStaff, date: e.target.value })}
                className="mt-1"
              />
            </div>

            <div className="grid grid-cols-3 gap-4">
              <div>
                <Label>H. Prévues</Label>
                <Input
                  type="number"
                  step="0.5"
                  min="0"
                  value={newStaff.heures_prevues}
                  onChange={(e) => setNewStaff({ ...newStaff, heures_prevues: parseFloat(e.target.value) || 0 })}
                  className="mt-1"
                />
              </div>
              <div>
                <Label>H. Réelles *</Label>
                <Input
                  type="number"
                  step="0.5"
                  min="0"
                  value={newStaff.heures_reelles}
                  onChange={(e) => setNewStaff({ ...newStaff, heures_reelles: parseFloat(e.target.value) || 0 })}
                  className="mt-1"
                />
              </div>
              <div>
                <Label>Taux (€/h)</Label>
                <Input
                  type="number"
                  step="0.5"
                  min="0"
                  value={newStaff.taux_horaire}
                  onChange={(e) => setNewStaff({ ...newStaff, taux_horaire: parseFloat(e.target.value) || 12 })}
                  className="mt-1"
                />
              </div>
            </div>

            <div className="p-3 bg-purple-50 border border-purple-200 rounded-lg">
              <div className="flex justify-between">
                <span className="text-sm text-purple-700">Coût prévu:</span>
                <span className="font-semibold">{(newStaff.heures_prevues * newStaff.taux_horaire).toFixed(2)} €</span>
              </div>
              <div className="flex justify-between mt-1">
                <span className="text-sm text-purple-700">Coût réel:</span>
                <span className="font-bold text-purple-800">{(newStaff.heures_reelles * newStaff.taux_horaire).toFixed(2)} €</span>
              </div>
            </div>

            <div>
              <Label>Notes</Label>
              <Input
                value={newStaff.notes}
                onChange={(e) => setNewStaff({ ...newStaff, notes: e.target.value })}
                placeholder="Optionnel..."
                className="mt-1"
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowStaffDialog(false)}>
              Annuler
            </Button>
            <Button onClick={handleAddStaff} disabled={savingStaff}>
              {savingStaff ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Plus className="w-4 h-4 mr-2" />}
              Ajouter
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Import Staff from Planning Dialog */}
      <Dialog open={showImportStaffDialog} onOpenChange={setShowImportStaffDialog}>
        <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Download className="w-5 h-5 text-purple-500" />
              Importer Staff depuis Planning HEC
            </DialogTitle>
          </DialogHeader>

          {loadingPlanningStaff ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="w-8 h-8 animate-spin text-purple-500" />
              <span className="ml-3">Chargement du planning...</span>
            </div>
          ) : staffFromPlanning?.status === "no_data" ? (
            <div className="text-center py-8 text-muted-foreground">
              <AlertCircle className="w-12 h-12 mx-auto mb-4 opacity-50 text-orange-500" />
              <p>Aucun planning HEC avec Staff Bar trouvé</p>
              <p className="text-sm mt-2">Créez d'abord un planning HEC avec des membres du Staff Bar</p>
            </div>
          ) : staffFromPlanning?.staff?.length > 0 ? (
            <>
              {staffFromPlanning.planning_info && (
                <div className="p-3 bg-blue-50 rounded-lg mb-4">
                  <p className="font-semibold text-blue-800">{staffFromPlanning.planning_info.nom_evenement}</p>
                  <p className="text-sm text-blue-600">
                    {staffFromPlanning.planning_info.date_debut} - {staffFromPlanning.planning_info.date_fin}
                  </p>
                </div>
              )}

              <div className="text-sm text-muted-foreground mb-4">
                <p>Les <strong>heures prévues</strong> sont récupérées du planning horaire HEC.</p>
                <p>Modifiez les <strong>heures réelles</strong> et le <strong>taux horaire</strong> pour chaque membre.</p>
              </div>

              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Nom</TableHead>
                    <TableHead>Fonction</TableHead>
                    <TableHead className="text-center">Taux/h</TableHead>
                    <TableHead className="text-center" colSpan={2}>Jeudi</TableHead>
                    <TableHead className="text-center" colSpan={2}>Vendredi</TableHead>
                    <TableHead className="text-center" colSpan={2}>Samedi</TableHead>
                    <TableHead className="text-right">Coût Total</TableHead>
                  </TableRow>
                  <TableRow className="bg-gray-50">
                    <TableHead></TableHead>
                    <TableHead></TableHead>
                    <TableHead></TableHead>
                    <TableHead className="text-center text-xs">Prévu</TableHead>
                    <TableHead className="text-center text-xs">Réel</TableHead>
                    <TableHead className="text-center text-xs">Prévu</TableHead>
                    <TableHead className="text-center text-xs">Réel</TableHead>
                    <TableHead className="text-center text-xs">Prévu</TableHead>
                    <TableHead className="text-center text-xs">Réel</TableHead>
                    <TableHead></TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {staffImportData.map((staff) => {
                    const totalHeuresReelles = (staff.heures_reelles_jeudi || 0) + (staff.heures_reelles_vendredi || 0) + (staff.heures_reelles_samedi || 0);
                    const coutTotal = staff.benevole ? 0 : totalHeuresReelles * staff.taux_horaire;
                    return (
                      <TableRow key={staff.staff_id} className={staff.benevole ? 'bg-green-50' : ''}>
                        <TableCell className="font-medium">
                          {staff.nom}
                          {staff.benevole && <Badge className="ml-2 bg-green-100 text-green-700 text-xs">Bénévole</Badge>}
                        </TableCell>
                        <TableCell>
                          <Badge variant="outline" className="text-xs">{staff.fonction}</Badge>
                        </TableCell>
                        <TableCell>
                          <Input
                            type="number"
                            step="0.5"
                            min="0"
                            value={staff.taux_horaire}
                            onChange={(e) => updateStaffImportData(staff.staff_id, 'taux_horaire', e.target.value)}
                            className="w-16 h-8 text-center text-sm"
                            disabled={staff.benevole}
                          />
                        </TableCell>
                        {/* Jeudi */}
                        <TableCell className="text-center bg-gray-50">
                          <span className="text-sm text-muted-foreground">{staff.heures_prevues_jeudi}h</span>
                        </TableCell>
                        <TableCell>
                          <Input
                            type="number"
                            step="0.5"
                            min="0"
                            value={staff.heures_reelles_jeudi}
                            onChange={(e) => updateStaffImportData(staff.staff_id, 'heures_reelles_jeudi', e.target.value)}
                            className="w-16 h-8 text-center text-sm"
                          />
                        </TableCell>
                        {/* Vendredi */}
                        <TableCell className="text-center bg-gray-50">
                          <span className="text-sm text-muted-foreground">{staff.heures_prevues_vendredi}h</span>
                        </TableCell>
                        <TableCell>
                          <Input
                            type="number"
                            step="0.5"
                            min="0"
                            value={staff.heures_reelles_vendredi}
                            onChange={(e) => updateStaffImportData(staff.staff_id, 'heures_reelles_vendredi', e.target.value)}
                            className="w-16 h-8 text-center text-sm"
                          />
                        </TableCell>
                        {/* Samedi */}
                        <TableCell className="text-center bg-gray-50">
                          <span className="text-sm text-muted-foreground">{staff.heures_prevues_samedi}h</span>
                        </TableCell>
                        <TableCell>
                          <Input
                            type="number"
                            step="0.5"
                            min="0"
                            value={staff.heures_reelles_samedi}
                            onChange={(e) => updateStaffImportData(staff.staff_id, 'heures_reelles_samedi', e.target.value)}
                            className="w-16 h-8 text-center text-sm"
                          />
                        </TableCell>
                        <TableCell className="text-right font-semibold">
                          {staff.benevole ? '-' : `${coutTotal.toFixed(2)} €`}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>

              <div className="mt-4 p-4 bg-purple-50 rounded-lg">
                <div className="grid grid-cols-3 gap-4 text-center">
                  <div>
                    <p className="text-sm text-purple-600">Total H. Prévues</p>
                    <p className="text-xl font-bold text-purple-800">
                      {staffImportData.reduce((sum, s) => sum + (s.heures_prevues_jeudi || 0) + (s.heures_prevues_vendredi || 0) + (s.heures_prevues_samedi || 0), 0)}h
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-purple-600">Total H. Réelles</p>
                    <p className="text-xl font-bold text-purple-800">
                      {staffImportData.reduce((sum, s) => sum + (s.heures_reelles_jeudi || 0) + (s.heures_reelles_vendredi || 0) + (s.heures_reelles_samedi || 0), 0)}h
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-purple-600">Coût Total Réel</p>
                    <p className="text-xl font-bold text-purple-800">
                      {staffImportData.reduce((sum, s) => {
                        if (s.benevole) return sum;
                        const h = (s.heures_reelles_jeudi || 0) + (s.heures_reelles_vendredi || 0) + (s.heures_reelles_samedi || 0);
                        return sum + (h * s.taux_horaire);
                      }, 0).toFixed(2)} €
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="text-center py-8 text-muted-foreground">
              <Users className="w-12 h-12 mx-auto mb-4 opacity-50" />
              <p>Aucun membre du Staff Bar dans le planning HEC</p>
            </div>
          )}

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowImportStaffDialog(false)}>
              Annuler
            </Button>
            <Button 
              onClick={handleImportStaffFromPlanning} 
              disabled={importingStaff || !staffImportData.length}
            >
              {importingStaff ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Download className="w-4 h-4 mr-2" />}
              Importer ({staffImportData.length} membres)
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dépense Dialog */}
      <Dialog open={showDepenseDialog} onOpenChange={setShowDepenseDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Wallet className="w-5 h-5 text-orange-500" />
              Ajouter Dépense Manuelle
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            <div>
              <Label>Description *</Label>
              <Input
                value={newDepense.description}
                onChange={(e) => setNewDepense({ ...newDepense, description: e.target.value })}
                placeholder="Ex: Location sono, Transport matériel..."
                className="mt-1"
              />
            </div>

            <div>
              <Label>Catégorie *</Label>
              <Select
                value={newDepense.categorie}
                onValueChange={(v) => setNewDepense({ ...newDepense, categorie: v })}
              >
                <SelectTrigger className="mt-1">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="materiel">📦 Matériel</SelectItem>
                  <SelectItem value="transport">🚗 Transport</SelectItem>
                  <SelectItem value="location">🏢 Location</SelectItem>
                  <SelectItem value="communication">📢 Communication</SelectItem>
                  <SelectItem value="assurance">🛡️ Assurance</SelectItem>
                  <SelectItem value="nettoyage">🧹 Nettoyage</SelectItem>
                  <SelectItem value="autre">📝 Autre</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Date *</Label>
                <Input
                  type="date"
                  value={newDepense.date}
                  onChange={(e) => setNewDepense({ ...newDepense, date: e.target.value })}
                  className="mt-1"
                />
              </div>
              <div>
                <Label>Montant (€) *</Label>
                <Input
                  type="number"
                  step="0.01"
                  min="0"
                  value={newDepense.montant}
                  onChange={(e) => setNewDepense({ ...newDepense, montant: parseFloat(e.target.value) || 0 })}
                  className="mt-1"
                />
              </div>
            </div>

            <div>
              <Label>Fournisseur</Label>
              <Input
                value={newDepense.fournisseur}
                onChange={(e) => setNewDepense({ ...newDepense, fournisseur: e.target.value })}
                placeholder="Optionnel..."
                className="mt-1"
              />
            </div>

            <div>
              <Label>Notes</Label>
              <Input
                value={newDepense.notes}
                onChange={(e) => setNewDepense({ ...newDepense, notes: e.target.value })}
                placeholder="Optionnel..."
                className="mt-1"
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowDepenseDialog(false)}>
              Annuler
            </Button>
            <Button onClick={handleAddDepense} disabled={savingDepense}>
              {savingDepense ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Plus className="w-4 h-4 mr-2" />}
              Ajouter
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Reclassement Dialog - Admin Only */}
      {isSuperAdmin && (
        <Dialog open={showReclassementDialog} onOpenChange={setShowReclassementDialog}>
          <DialogContent className="max-w-lg">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <ArrowRightLeft className="w-5 h-5 text-purple-500" />
                Reclasser le Montant Personnalisé
              </DialogTitle>
            </DialogHeader>

            {reclassementItem && (
              <div className="space-y-4">
                {/* Current Info */}
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold mb-2">Montant à reclasser</h4>
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <div>
                      <span className="text-muted-foreground">Date :</span> {reclassementItem.date}
                    </div>
                    <div>
                      <span className="text-muted-foreground">Prix TTC :</span>{" "}
                      <span className="font-semibold text-green-600">{reclassementItem.prix_ttc?.toLocaleString("fr-FR")} €</span>
                    </div>
                    <div className="col-span-2">
                      <span className="text-muted-foreground">Food Truck actuel :</span>{" "}
                      <Badge variant="outline">{reclassementItem.food_truck}</Badge>
                    </div>
                  </div>
                </div>

                {/* Target Selection */}
                <div>
                  <Label>Food Truck de destination *</Label>
                  <Select
                    value={reclassementTarget.food_truck}
                    onValueChange={(v) => setReclassementTarget({ ...reclassementTarget, food_truck: v, article: "" })}
                  >
                    <SelectTrigger className="mt-1">
                      <SelectValue placeholder="Sélectionner le food truck" />
                    </SelectTrigger>
                    <SelectContent>
                      {mbatData?.food_trucks?.map((ft) => (
                        <SelectItem key={ft.nom} value={ft.nom}>{ft.nom}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                <div>
                  <Label>Article *</Label>
                  <Select
                    value={reclassementTarget.article}
                    onValueChange={(v) => setReclassementTarget({ ...reclassementTarget, article: v })}
                    disabled={!reclassementTarget.food_truck}
                  >
                    <SelectTrigger className="mt-1">
                      <SelectValue placeholder="Sélectionner ou créer un article" />
                    </SelectTrigger>
                    <SelectContent>
                      {getArticlesForFoodTruck(reclassementTarget.food_truck).map((article) => (
                        <SelectItem key={article} value={article}>{article}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <p className="text-xs text-muted-foreground mt-1">
                    Ou saisissez un nouvel article :
                  </p>
                  <Input
                    className="mt-1"
                    placeholder="Nom du nouvel article..."
                    value={reclassementTarget.article}
                    onChange={(e) => setReclassementTarget({ ...reclassementTarget, article: e.target.value })}
                  />
                </div>

                <div className="p-3 bg-purple-50 border border-purple-200 rounded-lg text-sm text-purple-700">
                  <AlertCircle className="w-4 h-4 inline mr-2" />
                  Cette action va :
                  <ul className="list-disc list-inside mt-1 ml-4">
                    <li>Retirer ce montant de la liste des montants personnalisés</li>
                    <li>L'ajouter comme article au food truck sélectionné</li>
                    <li>Mettre à jour les totaux du food truck</li>
                  </ul>
                </div>
              </div>
            )}

            <DialogFooter>
              <Button variant="outline" onClick={() => setShowReclassementDialog(false)}>
                Annuler
              </Button>
              <Button 
                onClick={handleReclasserMontant} 
                disabled={savingReclassement || !reclassementTarget.food_truck || !reclassementTarget.article}
                className="bg-purple-600 hover:bg-purple-700"
              >
                {savingReclassement ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <ArrowRightLeft className="w-4 h-4 mr-2" />}
                Reclasser
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default CoutReelHECPage;
